var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-165"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.11,326.06,81,326.33l-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.44l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0L94,320.4c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.49-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.34,340.17l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.44l0-11.19v-.51h.5l13.24.06c4.41,0,8.82.11,13.24.16h.27V329c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.42.05-8.83.16-13.24.16l-13.24.06.5-.49-.06,11.19-.44-.45c2.18,0,4.36,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.89,181.84l-13.12.27-6.66.12c-2.23,0-4.46,0-6.7.05H426v-.44l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.12,196l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7,0h-.44V196l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5L412.09,196l-.45-.45c2.18,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.41,181.84l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.44l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.14,340.17l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44L670.16,329v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V329c0,1.89-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49,0,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.37,66.49l-13.12.27-6.67.12c-2.22,0-4.46,0-6.69.05h-.44v-.45l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.14,80.6,684,80.87l-6.66.12c-2.23,0-4.47,0-6.7.05h-.44V80.6l-.06-11.19V68.9h.5L683.9,69c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.14,5.65Zm0,0L697,74.94c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.11,66.49,81,66.76l-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.45L67.13,55.3v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0L94,60.83c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19L67.63,66c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.41,
    y: 45.67,
    width: 152.28,
    height: 203.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.79,
    y: 53.84,
    width: 62.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.55,
    y: 53.84,
    width: 62.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.79,
    y: 150.74,
    width: 62.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.55,
    y: 150.74,
    width: 62.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.41,
    y: 45.67,
    width: 40.81,
    height: 291.8,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.47 59.54 122.79 91.09 122.91 122.64 123.12 185.74 122.91 248.84 122.79 280.39 122.47 311.94 122.16 280.39 122.05 248.84 121.83 185.74 122.05 122.64 122.16 91.09 122.47 59.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.74 66.86 104.05 95.03 104.23 123.2 104.39 179.54 104.24 235.89 104.06 264.06 103.74 292.23 103.42 264.06 103.24 235.89 103.09 179.54 103.24 123.2 103.42 95.03 103.74 66.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.11 73.51 113.42 106.5 113.54 139.48 113.75 205.46 113.54 271.43 113.42 304.42 113.11 337.4 112.79 304.42 112.68 271.43 112.46 205.46 112.68 139.48 112.79 106.5 113.11 73.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.77 61.2 97.08 95.73 97.2 130.25 97.42 199.3 97.2 268.35 97.09 302.88 96.77 337.4 96.45 302.88 96.34 268.35 96.12 199.3 96.34 130.25 96.45 95.73 96.77 61.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.88,
    y: 45.67,
    width: 40.81,
    height: 291.8,
    transform: "translate(442.57 383.13) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.62 59.54 208.94 91.09 209.05 122.64 209.27 185.74 209.05 248.84 208.94 280.39 208.62 311.94 208.3 280.39 208.19 248.84 207.97 185.74 208.19 122.64 208.31 91.09 208.62 59.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.36 66.86 227.67 95.03 227.85 123.2 228 179.54 227.86 235.89 227.68 264.06 227.36 292.23 227.04 264.06 226.86 235.89 226.71 179.54 226.86 123.2 227.04 95.03 227.36 66.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.99 73.51 218.3 106.5 218.42 139.48 218.63 205.46 218.42 271.43 218.31 304.42 217.99 337.4 217.67 304.42 217.56 271.43 217.34 205.46 217.56 139.48 217.67 106.5 217.99 73.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.33 61.2 234.64 95.73 234.75 130.25 234.97 199.3 234.76 268.35 234.64 302.88 234.33 337.4 234.01 302.88 233.9 268.35 233.68 199.3 233.9 130.25 234.01 95.73 234.33 61.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.05,
    y: 45.67,
    width: 152.28,
    height: 203.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.44,
    y: 53.84,
    width: 62.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.2,
    y: 53.84,
    width: 62.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.44,
    y: 150.74,
    width: 62.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.2,
    y: 150.74,
    width: 62.75,
    height: 90.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.05,
    y: 45.67,
    width: 40.81,
    height: 291.8,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.12 59.54 374.44 91.09 374.55 122.64 374.77 185.74 374.55 248.84 374.44 280.39 374.12 311.94 373.81 280.39 373.69 248.84 373.48 185.74 373.69 122.64 373.81 91.09 374.12 59.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.39 66.86 355.7 95.03 355.88 123.2 356.03 179.54 355.88 235.89 355.7 264.06 355.39 292.23 355.07 264.06 354.89 235.89 354.74 179.54 354.89 123.2 355.07 95.03 355.39 66.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.75 73.51 365.07 106.5 365.18 139.48 365.4 205.46 365.19 271.43 365.07 304.42 364.75 337.4 364.44 304.42 364.32 271.43 364.11 205.46 364.32 139.48 364.44 106.5 364.75 73.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.42 61.2 348.73 95.73 348.85 130.25 349.06 199.3 348.85 268.35 348.73 302.88 348.42 337.4 348.1 302.88 347.99 268.35 347.77 199.3 347.99 130.25 348.1 95.73 348.42 61.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.53,
    y: 45.67,
    width: 40.81,
    height: 291.8,
    transform: "translate(945.87 383.13) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.27 59.54 460.58 91.09 460.7 122.64 460.91 185.74 460.7 248.84 460.58 280.39 460.27 311.94 459.95 280.39 459.84 248.84 459.62 185.74 459.84 122.64 459.95 91.09 460.27 59.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.01 66.86 479.32 95.03 479.5 123.2 479.65 179.54 479.5 235.89 479.32 264.06 479.01 292.23 478.69 264.06 478.51 235.89 478.36 179.54 478.51 123.2 478.69 95.03 479.01 66.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.64 73.51 469.95 106.5 470.07 139.48 470.28 205.46 470.07 271.43 469.95 304.42 469.64 337.4 469.32 304.42 469.21 271.43 468.99 205.46 469.21 139.48 469.32 106.5 469.64 73.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.97 61.2 486.29 95.73 486.4 130.25 486.62 199.3 486.4 268.35 486.29 302.88 485.97 337.4 485.66 302.88 485.54 268.35 485.33 199.3 485.55 130.25 485.66 95.73 485.97 61.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 611.33,
    cy: 77.44,
    r: 31.77,
    transform: "translate(430.24 666.45) rotate(-80.13)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612.79,
    cy: 78.15,
    r: 30.32,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 612.79,
    cy: 78.15,
    r: 28.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.55,72.12C627.61,80,606.36,92.81,594.48,99.86a28.28,28.28,0,0,1-7.76-10.44L626,53A28.42,28.42,0,0,1,640.55,72.12Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.17,79.14a28.06,28.06,0,0,1-1.88,9.23l-35.42,16.75a28.13,28.13,0,0,1-4.47-1.92C610.1,97,629.65,85.76,641.17,79.14Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.51,
    y: 51.81,
    width: 0.55,
    height: 4.3,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.42,
    y: 55.05,
    width: 0.55,
    height: 4.31,
    transform: "translate(51.86 307.98) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.57,
    y: 63.9,
    width: 0.55,
    height: 4.31,
    transform: "translate(238.68 545.55) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.45,
    y: 77.87,
    width: 4.3,
    height: 0.55,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.69,
    y: 89.97,
    width: 4.31,
    height: 0.55,
    transform: "translate(34.19 308.05) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.54,
    y: 98.82,
    width: 4.3,
    height: 0.55,
    transform: "translate(214.8 569.98) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.51,
    y: 100.18,
    width: 0.55,
    height: 4.31,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.61,
    y: 96.94,
    width: 0.55,
    height: 4.3,
    transform: "translate(34.17 325.72) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.46,
    y: 88.09,
    width: 0.55,
    height: 4.31,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, 238.68, 593.93)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.82,
    y: 77.87,
    width: 4.3,
    height: 0.55,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.58,
    y: 65.78,
    width: 4.31,
    height: 0.55,
    transform: "translate(51.9 325.76) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.73,
    y: 56.93,
    width: 4.31,
    height: 0.55,
    transform: "translate(263.16 569.95) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "613.2 53.76 614.14 80.06 611.44 80.03 612.47 53.75 613.2 53.76",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.59 68.97 611.89 80.27 610.6 77.9 629.24 68.33 629.59 68.97",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.71,78.15a.92.92,0,1,1-.92-.92A.92.92,0,0,1,613.71,78.15Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-165"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 420.49,
    rx: 313.6,
    ry: 39.85,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-165"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "47.76 368.36 129.57 368.12 211.38 368.03 375 367.86 538.62 368.03 620.43 368.12 702.24 368.36 620.43 368.61 538.62 368.69 375 368.86 211.38 368.69 129.57 368.61 47.76 368.36",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-165"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "127.12 408.33 176.6 389.25 468.22 408.33 536.56 124.52 165.47 124.52 127.12 408.33",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "127.12 408.33 176.6 389.25 468.22 408.33 536.56 124.52 165.47 124.52 127.12 408.33"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "606.04 408.33 234.95 408.33 166.6 124.52 537.7 124.52 606.04 408.33",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606.04 408.33 234.95 408.33 166.6 124.52 537.7 124.52 606.04 408.33",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.95 408.33 176.6 383.87 127.12 408.33 176.6 389.25 234.95 408.33",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.6 383.87 229.06 383.87 234.95 408.33 176.6 383.87",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.6 383.87 229.06 383.87 234.95 408.33 176.6 383.87",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.58,124.56a19.16,19.16,0,0,1,.25,9.19,11.68,11.68,0,0,1-2.45,5,9.27,9.27,0,0,1-6.81,3.38,5.49,5.49,0,0,1-.91-.07,2.21,2.21,0,1,1,.61-4.37,4.63,4.63,0,0,0,3.75-1.8,6.6,6.6,0,0,0,1.21-2.1c.91-2.37.83-5.53-.22-9.19,0-.09-.06-.19-.08-.28-1.66-5.48-5.24-7.92-7.77-7.44-2.25.43-3.44,3.21-3.09,7.26a2.34,2.34,0,0,1,0,.46h-4.39s0-.06,0-.09c-.65-7.77,3.19-11.31,6.67-12,4.54-.87,10.4,2.46,12.83,10.49C227.32,123.53,227.45,124.05,227.58,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.34,124.56a19.06,19.06,0,0,1,.26,9.19,11.91,11.91,0,0,1-2.45,5,9.29,9.29,0,0,1-6.82,3.38,5.58,5.58,0,0,1-.91-.07,2.21,2.21,0,0,1,.61-4.37,4.63,4.63,0,0,0,3.75-1.8,6.6,6.6,0,0,0,1.21-2.1c.91-2.37.84-5.53-.22-9.19,0-.09-.06-.19-.08-.28-1.66-5.48-5.25-7.91-7.77-7.44-2.24.43-3.43,3.21-3.08,7.26a2.34,2.34,0,0,1,0,.46h-4.4v-.09c-.66-7.77,3.18-11.31,6.67-12,4.53-.87,10.39,2.46,12.82,10.49C200.08,123.53,200.22,124.05,200.34,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.05,124.56a19.06,19.06,0,0,1,.26,9.19,11.79,11.79,0,0,1-2.46,5,9.26,9.26,0,0,1-6.81,3.38,5.49,5.49,0,0,1-.91-.07,2.21,2.21,0,1,1,.61-4.37,4.62,4.62,0,0,0,3.75-1.8,6.6,6.6,0,0,0,1.21-2.1c.91-2.37.83-5.53-.22-9.19,0-.09-.06-.19-.08-.28-1.66-5.48-5.24-7.92-7.77-7.44-2.24.43-3.43,3.21-3.09,7.26a1.76,1.76,0,0,1,0,.46h-4.39s0-.06,0-.09c-.65-7.77,3.19-11.31,6.68-12,4.53-.87,10.39,2.46,12.82,10.49C281.79,123.53,281.92,124.05,282.05,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81,124.56a19.06,19.06,0,0,1,.26,9.19,11.79,11.79,0,0,1-2.46,5,9.25,9.25,0,0,1-6.8,3.38,5.62,5.62,0,0,1-.92-.07,2.21,2.21,0,0,1,.61-4.37,4.66,4.66,0,0,0,3.76-1.8,6.6,6.6,0,0,0,1.21-2.1c.91-2.37.83-5.53-.23-9.19,0-.09-.06-.19-.08-.28-1.65-5.48-5.24-7.92-7.77-7.44-2.24.43-3.43,3.21-3.08,7.26a2.34,2.34,0,0,1,0,.46h-4.39s0-.06,0-.09c-.66-7.77,3.19-11.31,6.67-12,4.54-.87,10.39,2.46,12.82,10.49C254.55,123.53,254.69,124.05,254.81,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,124.56a19.16,19.16,0,0,1,.25,9.19,11.79,11.79,0,0,1-2.46,5,9.24,9.24,0,0,1-6.8,3.38,5.7,5.7,0,0,1-.92-.07,2.21,2.21,0,1,1,.62-4.37,4.63,4.63,0,0,0,3.75-1.8,6.6,6.6,0,0,0,1.21-2.1c.91-2.37.83-5.53-.22-9.19l-.09-.28c-1.65-5.48-5.24-7.92-7.76-7.44-2.25.43-3.44,3.21-3.09,7.26a2.34,2.34,0,0,1,0,.46h-4.39s0-.06,0-.09c-.65-7.77,3.19-11.31,6.67-12,4.54-.87,10.39,2.46,12.83,10.49C309,123.53,309.16,124.05,309.29,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.52,124.56a19.06,19.06,0,0,1,.26,9.19,11.79,11.79,0,0,1-2.46,5,9.25,9.25,0,0,1-6.8,3.38,5.62,5.62,0,0,1-.92-.07,2.21,2.21,0,1,1,.61-4.37,4.66,4.66,0,0,0,3.76-1.8,6.79,6.79,0,0,0,1.21-2.1c.9-2.37.82-5.53-.23-9.19l-.09-.28c-1.65-5.48-5.23-7.92-7.76-7.44-2.24.43-3.43,3.21-3.08,7.26,0,.16,0,.31,0,.46h-4.39s0-.06,0-.09c-.66-7.77,3.18-11.31,6.67-12,4.53-.87,10.39,2.46,12.82,10.49C336.26,123.53,336.39,124.05,336.52,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.76,124.56a19.06,19.06,0,0,1,.26,9.19,11.79,11.79,0,0,1-2.46,5,9.29,9.29,0,0,1-6.81,3.38,5.49,5.49,0,0,1-.91-.07,2.21,2.21,0,1,1,.61-4.37,4.63,4.63,0,0,0,3.75-1.8,6.6,6.6,0,0,0,1.21-2.1c.91-2.37.83-5.53-.22-9.19l-.09-.28c-1.65-5.48-5.24-7.92-7.76-7.44-2.24.43-3.43,3.21-3.09,7.26a2.34,2.34,0,0,1,0,.46h-4.39s0-.06,0-.09c-.65-7.77,3.19-11.31,6.67-12,4.53-.87,10.4,2.46,12.82,10.49C363.5,123.53,363.63,124.05,363.76,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.23,124.56a19.06,19.06,0,0,1,.26,9.19,11.79,11.79,0,0,1-2.46,5,9.27,9.27,0,0,1-6.81,3.38,5.58,5.58,0,0,1-.91-.07,2.21,2.21,0,1,1,.61-4.37,4.65,4.65,0,0,0,3.76-1.8,6.79,6.79,0,0,0,1.21-2.1c.89-2.37.82-5.53-.24-9.19,0-.09,0-.19-.08-.28-1.65-5.48-5.24-7.92-7.76-7.44-2.24.43-3.43,3.21-3.09,7.26a3.53,3.53,0,0,1,0,.46h-4.4s0-.06,0-.09c-.65-7.77,3.19-11.31,6.67-12,4.53-.87,10.4,2.46,12.82,10.49C418,123.53,418.1,124.05,418.23,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,124.56a19.06,19.06,0,0,1,.26,9.19,11.79,11.79,0,0,1-2.46,5,9.25,9.25,0,0,1-6.8,3.38,5.62,5.62,0,0,1-.92-.07,2.21,2.21,0,0,1,.61-4.37,4.65,4.65,0,0,0,3.76-1.8,6.79,6.79,0,0,0,1.21-2.1c.9-2.37.83-5.53-.23-9.19l-.09-.28c-1.64-5.48-5.23-7.92-7.75-7.44-2.25.43-3.44,3.21-3.09,7.26,0,.16,0,.31,0,.46h-4.39s0-.06,0-.09c-.65-7.77,3.19-11.31,6.67-12,4.52-.87,10.39,2.46,12.82,10.49C390.73,123.53,390.86,124.05,391,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.47,124.56a19.06,19.06,0,0,1,.26,9.19,11.79,11.79,0,0,1-2.46,5,9.29,9.29,0,0,1-6.81,3.38,5.49,5.49,0,0,1-.91-.07,2.21,2.21,0,1,1,.61-4.37,4.63,4.63,0,0,0,3.75-1.8,6.79,6.79,0,0,0,1.21-2.1c.9-2.37.83-5.53-.23-9.19,0-.09-.05-.19-.08-.28-1.65-5.48-5.24-7.92-7.76-7.44-2.25.43-3.44,3.21-3.1,7.26a2.36,2.36,0,0,1,0,.46h-4.39s0-.06,0-.09c-.65-7.77,3.18-11.31,6.67-12,4.53-.87,10.4,2.46,12.82,10.49C445.21,123.53,445.34,124.05,445.47,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.94,124.56a19.06,19.06,0,0,1,.26,9.19,11.79,11.79,0,0,1-2.46,5,9.28,9.28,0,0,1-6.82,3.38,5.54,5.54,0,0,1-.9-.07,2.21,2.21,0,1,1,.61-4.37,4.63,4.63,0,0,0,3.75-1.8,6.79,6.79,0,0,0,1.21-2.1c.9-2.37.83-5.53-.23-9.19,0-.09-.05-.19-.08-.28-1.65-5.48-5.22-7.92-7.76-7.44-2.25.43-3.43,3.21-3.1,7.26a2.36,2.36,0,0,1,0,.46H480s0-.06,0-.09c-.65-7.77,3.18-11.31,6.67-12,4.54-.87,10.4,2.46,12.82,10.49C499.68,123.53,499.81,124.05,499.94,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525,138.71a9.29,9.29,0,0,1-6.82,3.38,5.46,5.46,0,0,1-.9-.07,2.21,2.21,0,1,1,.61-4.37,4.65,4.65,0,0,0,3.75-1.8c2.09-2.45,2.41-6.57.9-11.57-1.65-5.48-5.24-7.91-7.76-7.44-2.26.43-3.44,3.21-3.1,7.26a2.34,2.34,0,0,1,0,.46h-4.38s0-.06,0-.09c-.65-7.77,3.18-11.31,6.66-12,4.54-.87,10.4,2.46,12.83,10.49C529.39,131.78,526.77,136.62,525,138.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.7,124.56a19.06,19.06,0,0,1,.26,9.19,11.79,11.79,0,0,1-2.46,5,9.26,9.26,0,0,1-6.81,3.38,5.58,5.58,0,0,1-.91-.07,2.21,2.21,0,0,1,.61-4.37,4.64,4.64,0,0,0,3.76-1.8,6.79,6.79,0,0,0,1.21-2.1c.9-2.37.83-5.53-.24-9.19,0-.09-.05-.19-.08-.28-1.64-5.48-5.22-7.92-7.75-7.44-2.25.43-3.44,3.21-3.1,7.26a3.53,3.53,0,0,1,0,.46H452.8s0-.06,0-.09c-.65-7.77,3.18-11.31,6.66-12,4.54-.87,10.4,2.46,12.82,10.49C472.44,123.53,472.57,124.05,472.7,124.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.13 209.28 221.69 209.28 212.48 170.84 250.92 170.84 260.13 209.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.57 209.28 266.14 209.28 256.93 170.84 295.37 170.84 304.57 209.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.06 209.28 310.63 209.28 301.42 170.84 339.86 170.84 349.06 209.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.53 209.28 355.1 209.28 345.89 170.84 384.32 170.84 393.53 209.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438 209.28 399.57 209.28 390.36 170.84 428.79 170.84 438 209.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "482.47 209.28 444.04 209.28 434.83 170.84 473.26 170.84 482.47 209.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526.94 209.28 488.5 209.28 479.3 170.84 517.73 170.84 526.94 209.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.54 252.75 232.11 252.75 222.9 214.31 261.33 214.31 270.54 252.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.01 252.75 276.57 252.75 267.37 214.31 305.8 214.31 315.01 252.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.48 252.75 321.04 252.75 311.83 214.31 350.27 214.31 359.48 252.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.95 252.75 365.51 252.75 356.3 214.31 394.74 214.31 403.95 252.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.42 252.75 409.98 252.75 400.77 214.31 439.21 214.31 448.42 252.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "492.89 252.75 454.45 252.75 445.24 214.31 483.68 214.31 492.89 252.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "537.36 252.75 498.92 252.75 489.71 214.31 528.15 214.31 537.36 252.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.96 296.22 242.52 296.22 233.31 257.78 271.75 257.78 280.96 296.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.43 296.22 286.99 296.22 277.78 257.78 316.22 257.78 325.43 296.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.89 296.22 331.46 296.22 322.25 257.78 360.69 257.78 369.89 296.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.36 296.22 375.93 296.22 366.72 257.78 405.15 257.78 414.36 296.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.83 296.22 420.4 296.22 411.19 257.78 449.62 257.78 458.83 296.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "503.3 296.22 464.87 296.22 455.66 257.78 494.09 257.78 503.3 296.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "547.77 296.22 509.33 296.22 500.13 257.78 538.56 257.78 547.77 296.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.37 339.69 252.94 339.69 243.73 301.25 282.16 301.25 291.37 339.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.84 339.69 297.41 339.69 288.2 301.25 326.63 301.25 335.84 339.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.31 339.69 341.87 339.69 332.67 301.25 371.1 301.25 380.31 339.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.78 339.69 386.34 339.69 377.13 301.25 415.57 301.25 424.78 339.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.25 339.69 430.81 339.69 421.6 301.25 460.04 301.25 469.25 339.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.72 339.69 475.28 339.69 466.07 301.25 504.51 301.25 513.72 339.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "558.18 339.69 519.75 339.69 510.54 301.25 548.98 301.25 558.18 339.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.79 383.16 263.35 383.16 254.14 344.73 292.58 344.73 301.79 383.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.26 383.16 307.82 383.16 298.61 344.73 337.05 344.73 346.26 383.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.73 383.16 352.29 383.16 343.08 344.73 381.52 344.73 390.73 383.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.19 383.16 396.76 383.16 387.55 344.73 425.99 344.73 435.19 383.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.66 383.16 441.23 383.16 432.02 344.73 470.45 344.73 479.66 383.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "524.13 383.16 485.7 383.16 476.49 344.73 514.92 344.73 524.13 383.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "568.6 383.16 530.17 383.16 520.96 344.73 559.39 344.73 568.6 383.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.84,161.27a2.42,2.42,0,0,0-.75-.45,2.78,2.78,0,0,0-1-.17,1.45,1.45,0,0,0-1,.29.77.77,0,0,0-.16.78,1.07,1.07,0,0,0,.2.43,1,1,0,0,0,.35.28,2.17,2.17,0,0,0,.55.22l.76.17c.32.07.62.14.88.22a2.65,2.65,0,0,1,.7.31,1.59,1.59,0,0,1,.8,1.09,1.31,1.31,0,0,1,0,.68.94.94,0,0,1-.31.49,1.42,1.42,0,0,1-.59.29,3.35,3.35,0,0,1-.81.09,4.29,4.29,0,0,1-2.51-.83l.17-.46a3.2,3.2,0,0,0,.45.3,2.9,2.9,0,0,0,.53.26,4.24,4.24,0,0,0,.61.17,3.39,3.39,0,0,0,.64.06,1.67,1.67,0,0,0,1-.25.66.66,0,0,0,.21-.75,1.18,1.18,0,0,0-.22-.45,1.34,1.34,0,0,0-.41-.31,2.5,2.5,0,0,0-.59-.23l-.8-.2a8.61,8.61,0,0,1-.85-.22,2.77,2.77,0,0,1-.65-.28,1.61,1.61,0,0,1-.45-.41,1.67,1.67,0,0,1-.25-.59,1.44,1.44,0,0,1,0-.71,1.05,1.05,0,0,1,.3-.52,1.56,1.56,0,0,1,.57-.31,2.76,2.76,0,0,1,.8-.11,3.38,3.38,0,0,1,1.07.17,3.77,3.77,0,0,1,.93.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.74,165.47a1.57,1.57,0,0,0,.85-.2,1.15,1.15,0,0,0,.45-.55,1.84,1.84,0,0,0,.12-.76,5.23,5.23,0,0,0-.13-.87l-.69-2.9h.57l.69,2.9a5,5,0,0,1,.14,1.11,2.22,2.22,0,0,1-.2.92,1.51,1.51,0,0,1-.6.63,2.1,2.1,0,0,1-1.07.23,2.9,2.9,0,0,1-1.21-.24,2.84,2.84,0,0,1-.9-.66,3.49,3.49,0,0,1-.63-.92,5.67,5.67,0,0,1-.38-1.07l-.69-2.9h.56l.69,2.9a6.51,6.51,0,0,0,.3.88,3.06,3.06,0,0,0,.49.77,2.28,2.28,0,0,0,.7.53A2,2,0,0,0,229.74,165.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,161.24l1.13,4.7h-.57l-1.38-5.75h.44l5,4.79-1.14-4.78h.56l1.38,5.74H238Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.09,165.94,270,161.22l-1.23,3.65h-.33l-3-3.65,1.13,4.72H266l-1.38-5.75h.59l3.18,3.94,1.32-3.94h.58l1.38,5.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.43,166a2.9,2.9,0,0,1-1.16-.24,4,4,0,0,1-1-.66,3.72,3.72,0,0,1-.78-.94,3.94,3.94,0,0,1-.45-1.07A3,3,0,0,1,272,162a2.22,2.22,0,0,1,.35-.93,2,2,0,0,1,.7-.64,2.08,2.08,0,0,1,1-.24,2.74,2.74,0,0,1,1.15.25,4.09,4.09,0,0,1,1,.67,4.65,4.65,0,0,1,.77.94,3.88,3.88,0,0,1,.45,1.06,2.8,2.8,0,0,1,.05,1.11,2.12,2.12,0,0,1-.34.92,2,2,0,0,1-.7.65A2.18,2.18,0,0,1,275.43,166Zm-2.83-2.91a2.91,2.91,0,0,0,.37.9,3.09,3.09,0,0,0,.62.77,3,3,0,0,0,.8.53,2,2,0,0,0,.91.2,1.61,1.61,0,0,0,.84-.21,1.5,1.5,0,0,0,.54-.55,1.93,1.93,0,0,0,.24-.77,2.58,2.58,0,0,0-.06-.87,3.14,3.14,0,0,0-.38-.91,3.27,3.27,0,0,0-.62-.76,3,3,0,0,0-.8-.53,2,2,0,0,0-.91-.2,1.67,1.67,0,0,0-.83.2,1.5,1.5,0,0,0-.54.55,2.12,2.12,0,0,0-.25.77A2.41,2.41,0,0,0,272.6,163.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.63,161.24l1.12,4.7h-.56l-1.38-5.75h.43l5,4.79-1.14-4.78h.56l1.38,5.74h-.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,160.69H313l1.26,5.25h-.57l-1.26-5.25h-2.05l-.12-.5h4.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.35,165.47a1.63,1.63,0,0,0,.86-.2,1.19,1.19,0,0,0,.44-.55,1.84,1.84,0,0,0,.12-.76,4.36,4.36,0,0,0-.13-.87l-.69-2.9h.57l.69,2.9a5,5,0,0,1,.14,1.11,2.22,2.22,0,0,1-.2.92,1.51,1.51,0,0,1-.6.63,2.1,2.1,0,0,1-1.07.23,2.94,2.94,0,0,1-1.21-.24,2.84,2.84,0,0,1-.9-.66,3.75,3.75,0,0,1-.63-.92,5.67,5.67,0,0,1-.38-1.07l-.69-2.9h.56l.69,2.9a5.4,5.4,0,0,0,.31.88,3,3,0,0,0,.48.77,2.28,2.28,0,0,0,.7.53A2,2,0,0,0,319.35,165.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,165.44l.12.5h-3.86l-1.38-5.75h3.79l.12.5h-3.22l.5,2.08h2.81l.11.47h-2.81l.53,2.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.85,160.23h.53l1.3,2,.33-2h.54l-.41,2.46,1.72,2.6.86-5.1h.62l-1.06,5.75h-.5l-1.89-2.84-.54,2.84h-.49l-3.81-5.75h.61l3.31,5.1.47-2.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.27,165.44l.12.5h-3.86l-1.38-5.75h3.79l.12.5h-3.22l.5,2.08h2.81l.11.47h-2.81l.53,2.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.46,165.94l-1.37-5.75h2a3.4,3.4,0,0,1,1.26.23,3.27,3.27,0,0,1,1,.61,3.6,3.6,0,0,1,.74.91,4,4,0,0,1,.44,1.12,3.11,3.11,0,0,1,.09,1.19,1.88,1.88,0,0,1-.34.9,1.82,1.82,0,0,1-.72.59,2.79,2.79,0,0,1-1.09.2Zm3.45-2.88a3.3,3.3,0,0,0-.37-.95,3.19,3.19,0,0,0-.6-.75,2.7,2.7,0,0,0-1.78-.67h-1.39l1.14,4.75h1.39a2.06,2.06,0,0,0,.9-.18,1.36,1.36,0,0,0,.56-.5A1.7,1.7,0,0,0,372,164,2.85,2.85,0,0,0,371.91,163.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,160.69h-2.05l1.25,5.25h-.56l-1.26-5.25h-2.05l-.12-.5h4.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.7,160.19l1.38,5.75h-.56l-.64-2.69h-3.41l.64,2.69h-.57l-1.37-5.75h.56l.62,2.56h3.41l-.62-2.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.75,165.47a1.59,1.59,0,0,0,.85-.2,1.15,1.15,0,0,0,.45-.55,1.84,1.84,0,0,0,.11-.76,4.34,4.34,0,0,0-.12-.87l-.69-2.9h.56l.7,2.9a4.41,4.41,0,0,1,.13,1.11,2.22,2.22,0,0,1-.19.92,1.51,1.51,0,0,1-.6.63,2.1,2.1,0,0,1-1.07.23,2.87,2.87,0,0,1-1.21-.24,2.84,2.84,0,0,1-.9-.66,3.27,3.27,0,0,1-.63-.92,5.67,5.67,0,0,1-.38-1.07l-.69-2.9h.55l.7,2.9a4.57,4.57,0,0,0,.3.88,3.06,3.06,0,0,0,.49.77,2.16,2.16,0,0,0,.7.53A2,2,0,0,0,413.75,165.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.55,165.94l-1.37-5.75H450l.12.5h-3.21l.51,2.12h2.71l.11.47h-2.71l.64,2.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.33,165.94,451,160.19h2.43a1.64,1.64,0,0,1,.72.16,2.26,2.26,0,0,1,.64.41,2.48,2.48,0,0,1,.49.58,2.08,2.08,0,0,1,.28.66,1.8,1.8,0,0,1,.06.6,1.43,1.43,0,0,1-.14.52,1.16,1.16,0,0,1-.31.39,1.06,1.06,0,0,1-.47.21l1.94,2.22H456l-1.86-2.12h-1.7l.51,2.12Zm-.06-2.62h1.88a.86.86,0,0,0,.43-.11.74.74,0,0,0,.28-.3,1.09,1.09,0,0,0,.13-.42,1.65,1.65,0,0,0,0-.49,1.39,1.39,0,0,0-.22-.5,1.73,1.73,0,0,0-.79-.7,1.19,1.19,0,0,0-.47-.11h-1.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.62,165.94l-1.38-5.75h.57l1.38,5.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.08,161.27a2.47,2.47,0,0,0-.76-.45,2.73,2.73,0,0,0-1-.17,1.44,1.44,0,0,0-1,.29.77.77,0,0,0-.16.78,1.06,1.06,0,0,0,.19.43,1.15,1.15,0,0,0,.36.28,2.17,2.17,0,0,0,.55.22l.76.17c.32.07.62.14.88.22a2.65,2.65,0,0,1,.7.31,1.64,1.64,0,0,1,.5.44,1.7,1.7,0,0,1,.3.65,1.43,1.43,0,0,1,0,.68,1,1,0,0,1-.32.49,1.38,1.38,0,0,1-.58.29,3.35,3.35,0,0,1-.81.09,4.26,4.26,0,0,1-2.51-.83l.17-.46a3.07,3.07,0,0,0,.44.3,3.36,3.36,0,0,0,.54.26,3.78,3.78,0,0,0,.6.17,3.49,3.49,0,0,0,.65.06,1.67,1.67,0,0,0,1-.25.67.67,0,0,0,.2-.75,1,1,0,0,0-.22-.45,1.29,1.29,0,0,0-.4-.31,2.78,2.78,0,0,0-.6-.23c-.23-.07-.5-.13-.8-.2s-.6-.14-.85-.22a2.88,2.88,0,0,1-.64-.28,1.61,1.61,0,0,1-.45-.41,1.68,1.68,0,0,1-.26-.59,1.56,1.56,0,0,1,0-.71,1.05,1.05,0,0,1,.3-.52,1.6,1.6,0,0,1,.58-.31,2.71,2.71,0,0,1,.8-.11,3.27,3.27,0,0,1,1.06.17,4,4,0,0,1,.94.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.06,160.19h.48l3.77,5.75h-.6l-1.18-1.8H496l-.31,1.8H495Zm2.24,3.51-1.84-2.85-.5,2.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.4,160.69h-2l1.25,5.25H502l-1.26-5.25h-2l-.12-.5h4.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,295.35c-.06,0,.15.2.18.24C331.19,295.46,330.92,295.31,331,295.35Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.27 294.11 331.34 294.2 331.25 293.89 331.27 294.11",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,293.33c-.4-.23-.2.33-.44.36l-.1,0,.21.31C331.76,293.75,331.78,293.36,332,293.33Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.1,293.58c-.16-.09,0-.19-.13.06h0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,293.65c-.06.09.16.05,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.29,293.21l0,.21c.1.05.2,0,.23.06C333.57,293.31,333.48,293.26,333.29,293.21Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.13,292.88v.1S333.2,293,333.13,292.88Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.13,293.19V293c-.07,0-.18-.13,0,.09C333,293,333.1,293.08,333.13,293.19Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,293.21c-.13,0-.25,0-.27-.18C332.61,293.28,332.88,293.46,333,293.21Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.67,293h-.18l.05.17C331.52,293.05,331.78,293.07,331.67,293Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.08,292.69a3.16,3.16,0,0,0-.33-.21v.15C333.85,292.64,334,292.6,334.08,292.69Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.75,292.48l0-.23C333.62,292.34,333.66,292.41,333.75,292.48Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.77 292.52 332.86 292.95 332.8 292.48 332.77 292.52",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.5 292.24 334.61 292.46 334.46 292.11 334.5 292.24",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.75,291.91c.09.18.3.15.33.28a.71.71,0,0,0-.05-.44C335,291.87,335,291.92,334.75,291.91Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,291.5a1.09,1.09,0,0,0,.06.25A.69.69,0,0,0,335,291.5Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,292.08a.48.48,0,0,0,.29.09L334,292Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,292h0l.1-.09Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,292.09h0S333.92,292.06,333.94,292.09Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.24,292.37c-.05-.17,0-.43-.34-.44C333,292.1,333.16,292.11,333.24,292.37Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.64,291.91l-.17.09c.06.05.16.09.18.18Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.63 291.79 333.63 291.91 333.69 291.88 333.63 291.79",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.58,291.54a.32.32,0,0,1,.05-.28.76.76,0,0,0-.26.16C334.43,291.49,334.51,291.63,334.58,291.54Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.28,291.76v0S334.24,291.73,334.28,291.76Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.24,290.6l-.05,0,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.32,291.4c-.09,0-.07.1,0,.19a.53.53,0,0,1,.08-.17S334.33,291.38,334.32,291.4Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,291.23h-.2C334.93,291.25,335.08,291.28,335,291.23Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.35,291.77v0C334.41,291.81,334.39,291.79,334.35,291.77Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.35,291.77a1.89,1.89,0,0,0-.06-.18.77.77,0,0,0,0,.15Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.11,289.21c.18.18.23.48-.09.42,0,.25.73.74,1.17.94a.42.42,0,0,1-.15-.37c-.14-.05-.5.06-.57-.2s.19-.08.36-.07c-.29-.14-.15-.52-.53-.79v.25C334.24,289.35,334.2,289.22,334.11,289.21Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,290.79l0,.08a.77.77,0,0,1,.42.05.47.47,0,0,0-.12-.31l-.26.23Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.72,291.1c-.17-.23-.14-.43-.43-.55-.13.16.07.26.08.43.17-.29.05.17.33.1a.42.42,0,0,1-.07.18l.21,0h0s-.05,0,0,0h0l-.07-.08c.11,0,.07,0,.07.08l0,0h0l.11-.34C334.86,290.89,334.8,291,334.72,291.1Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.57,291.4l.06,0S332.61,291.37,332.57,291.4Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.79,291.41s.08.13,0,.17-.1-.09-.17-.15,0,.26.23.24v0a1,1,0,0,1,.55.11A3.25,3.25,0,0,0,332.79,291.41Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.71,291.2l.08-.3-.27,0,.11.09C333.49,291,333.64,291.11,333.71,291.2Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.36 290.67 335.56 290.89 335.36 290.49 335.36 290.67",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.58 290.38 335.76 290.56 335.71 290.38 335.58 290.38",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.81,273.31v0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.41,273.74l.08.09C346.46,273.76,346.43,273.72,346.41,273.74Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.47,283.85c.26.07.62.22.4,0l-.24-.16C341.62,283.83,341.55,283.85,341.47,283.85Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.28,278.28l-.09,0,.15.24Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48,277.45h.23A.45.45,0,0,0,343.48,277.45Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.75,270.75l-.15-.26C348.5,270.6,348.65,270.64,348.75,270.75Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,287.59a.47.47,0,0,0,.29-.07C338.06,287.5,337.82,287.42,338,287.59Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.86,275.47a.21.21,0,0,0-.08-.17A.19.19,0,0,0,348.86,275.47Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46,287.3h-.08a.35.35,0,0,1-.12.22C338.41,287.53,338.54,287.5,338.46,287.3Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.72,262.31h0S356.73,262.3,356.72,262.31Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.09,261.7a.59.59,0,0,1-.08.11S361.07,261.77,361.09,261.7Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.64,289.39c0,.07,0,0,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.57,288.93a.35.35,0,0,0-.08-.12A.49.49,0,0,1,335.57,288.93Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.68,285.58h0C337.63,285.55,337.64,285.56,337.68,285.58Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.47,289.39h.12A.28.28,0,0,0,336.47,289.39Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57,289.47l-.06,0S336.57,289.55,336.57,289.47Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7,289.3a.28.28,0,0,1-.11.08h.05Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.1,267.41h0C353.09,267.29,353.08,267.32,353.1,267.41Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.64,280.45h0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.67,280.11c.18.32.11.34,0,.35l.66.47Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.7,272.22l-.32,0c-.15-.44.07-.47-.31-.57.63.6-.44.61.19,1.21l-.22,0s0-.06,0-.08c-.48-.1.35.56,0,.71a.22.22,0,0,1-.3-.12v.33c-.06,0-.16-.07-.1-.11l-.2.32,0,0a2.7,2.7,0,0,1,.17.47c-.16,0,0-.1-.13-.16v.3c-.22-.09-.27-.36-.15-.45-.78-.44.05.28-.61.24l.05-.21c-.46-.24-.42,0-.8,0,.15.07.87.19.88.5-.09,0-.17,0-.12.25-.23-.2-.25-.06-.34.06l-.3-.29c0,.2.15.33.22.53-.15.1-.41-.08-.64-.23-.24.17.51.19.34.5-.27.07-.26.3-.27.68-.22,0-.17-.19-.3-.22l.15.32s-.1-.05-.13-.09c0,.18.3.28.25.5.3.35-.76-.14-.54.38-.13,0-.17-.19-.3-.28a2.19,2.19,0,0,0,.14.88h-.36c.35.08.47.49.57.83l.35.12,0,.37c-.07,0-.16-.13-.25-.28l0,.1c-.18,0-.32-.22-.44-.43l.26.09a2.24,2.24,0,0,0-.48-.61.19.19,0,0,1,0,.15.29.29,0,0,0-.11-.13s0,.06.06.17l-.39-.26.12.14-.48.1c.15.52.49,1.16.33,1.62-.18-.31-.4-.39-.69-.66.4.19.1-.38.33-.49-.12.06-.24-.09-.27-.16v.57c-.23-.23-.24-.1-.41-.11.53.37.11.52.14.78-.17-.14-.31-.32-.13-.43-.51-.16.37.72-.09.61,0,0,.07,0,0-.12.07.21-.24.32-.34.15l0,0c-.28.2-.69.75-.32,1.16-.05-.05-.46-.48-.53-.57l1,1.68c-.31-.35-1.28-.95-1.29-1.34-.11,0-.23,0-.22.28.08,0,.59.35.58.43a3.26,3.26,0,0,0-.81-.19c.13,0,.62.57.51.65-.07-.09-.55-.48-.57-.57l.32.73c0-.15-.45-.42-.65-.51.13.07-.19.2-.2.31h.22c-.33.2.51.95.24,1.19-.08-.13-.61-.69-.8-.62a6.37,6.37,0,0,1,1.07,1.9l-.2-.1v.35a16.33,16.33,0,0,1-1.07-2.07c-.22,0-.21-.14-.34,0a.23.23,0,0,1-.11-.33l-.42.26c.34.28.08.56.36.79v-.68c.34.27.71,1,.43,1.24-.18-.05-.53-.56-.64-.66.08.14,0,.43-.1.38l-.08-.26c-.25,0,.22.61-.24.5-.07,0-.57-.2-.39,0a8.93,8.93,0,0,1,1.83,1.56,4,4,0,0,1-.87-.12c-.37-.16-.56-.76-.88-.9a.71.71,0,0,1,.16.29c-.13,0-.25-.27-.33-.1.31.31-.27.24.22.31,0,.21-.19.07-.31.24a1.66,1.66,0,0,1,.57,1,1.14,1.14,0,0,0-.27-.18c-.27.24-.55.24-.77.49-.1-.05-.31,0-.4-.2,0,.09.1.22,0,.31-.41-.11.11-.21-.33-.41.18.18.09.44.11.65.32.23.28-.2.26-.41a1.76,1.76,0,0,1,.61,1.35c-.09.3-.34-.14-.32-.06-.42.32.41,1-.17,1-.37-.1-.52-.45-.73-.59.06-.26.4-.11.49-.23l-.25,0c0-.13,0-.3.13-.3-.33-.1-.63.61-1.12.72,0,.13,0,.3.19.35l.05-.13c.29.1.13.44.33.4,0,.26.14.61-.14.68l-.33-.23c.09.07.28,0,.24-.09.06.19-.64-.09-.33.34l.31.06c0,.26.21.69,0,.77.36.19,0-.07.44.13-.51-.29.38-.39-.2-.63.5.24.34-.05.82.1-.1-.08-.24-.11-.07-.2a.6.6,0,0,1-.06-.11h0s0,0,0,0a.58.58,0,0,1-.21-.07c-.16-.26,0-.47,0-.64.11,0,.08.13.22.18l-.08-.26c.23.19.55.12.51.41l.16-.15c.21,0,.38-.08.36-.25s-.06-.41.05-.19l.1-.38.06,0c.26-.23.12-.85.78-.79a.4.4,0,0,1,.23-.38l.21.14c0-.17.49-.16.33-.38.61.33.6-.44.87-.56l-.24-.22a1,1,0,0,0,.24-.57l-.23-.18c0-.3.49-.23.68-.48.06.09,0,.13-.1.12.73.17.17-.88.75-.81,0-.13,0-.15.13-.15v0l0,0,.19,0-.18,0a.53.53,0,0,0,.09-.27l.25.18s0,0,0,0c.15,0-.06-.15-.26-.27a.9.9,0,0,0-.06-.22c.42.28,0-.3.51,0-.15-.22.18-.48-.2-.89.06.05.1.05.07.09.12,0,.24-.07.18-.24l.33.23-.24-.53a.63.63,0,0,1,.55.41c-.12-.56.05-.31-.1-.84l.18.19c.06-.09-.08-.44.11-.34.52.15.81-.79,1.54-.93-.63-.41.44,0,0-.38.16.09.28.1.34.27.07-.34.51-.14.28-.62.16.09.15.22.25.27s-.05-.18.05-.13.08.13.11.22c.18-.25-.21-.64-.57-1,.28,0,.31,0,.14-.34.16.08.35.13.26.31.09-.06.63-.32.33-.6.1,0,.12-.09.1-.15.18-.16.23-.15.36-.35h-.1c-.3-.4.05-.22.14-.4l0,0c.56-.08,0-.25.59-.3l-.24-.19c-.47-.47.54,0,.52-.37l-.19-.05c-.08-.25.93.32,1.08.28s0,.09,0,.15c.53,0-.27-.3-.16-.56.2.11.37.41.52.31.19.05-.17-.86.3-.76-.16-.08-.32-.15-.33-.32s.82,0,.54-.44a.23.23,0,0,1,.12.06c0-.2.15-.5,0-.76.88.62.22-1,1-.35l.26-.37.06.08c.24-.17.14-.4,0-.63.09,0,.13.09.16.13.43-.18.43-.24.3-.82l.26.18c-.07-.19.78-.11.78-.66a.32.32,0,0,1,.07.13c0-.59,1.4-.23.65-1.13v-.42c-.33.24-.33-.38-.58-.39.05-.16.53-.06.44.12h-.06c.4.45.49-.22.79.06.5-.59,1.25-.92,1.76-1.44l-.41-.26.19-.17c.13,0,.34.19.2.31.26.1,0-.38,0-.45.37-.13.31.47.39.4l.07-.14H355c-.06-.21-.21-.36,0-.5s.26.14.31.11.05,0,.07-.05l.24-.21-.36-.15c0-.23.21-.21-.2-.39.63.28,1-.72,1.21-.68a.56.56,0,0,1,.26-.63c-.1,0-.44-.26-.26-.38.59.63.54,0,1.11.26-.41-.16.32-.51-.27-.72.17-.09.25.2.49.24,0-.53.77-.53,1-1-.07-.08-.26-.14-.31-.33l.6.18c0-.11-.42-.51,0-.38-.09,0-.22-.11-.2-.19,1.09-.37,1-1.82,2.5-1.88-.26,0-.21-.12-.15-.21s-.2-.19-.33-.28l.61,0c-.27-.34.28-.36,0-.66l0,.15c-.23-.46-1-.53-1.4-1,.27.51-1-.15-.6.62-.14,0-.1-.18-.24-.25.14.24.12.35-.1.41l0-.06c-.31.43-.65.42-1.18.75l.26.17a.45.45,0,0,1-.3,0c.24.42.26-.24.54.2-.57-.3-.6.65-1.2.26-.14.15.3.2.16.34l-.17-.09.15.2c-.12.07-.34,0-.47-.15,0,0,0-.09,0-.13-.28,0-.26.4-.35.39l.22-.06c-.23.52-.85.83-.91,1.47l.13.07c-.07.47-.33.13-.53.53v0a.33.33,0,0,1-.07.37c-.05-.19-.38-.06-.42-.29-.08.5,0,.3.23.87l-.22-.11c.1.21.18.29.08.49,0-.26-.37-.14-.43-.46-.7,0-.06.85-.77.49.35.59.53,0,.56.13.23.08.25.46.11.52s-.8-.38-1-.1c0,0,0-.06,0-.09-.22,0,0,.35-.33.29.24.34-.16.15.2.51l.14-.33c0,.23.29.76-.13.8a.89.89,0,0,1-.11-.35c-.18,0-.05.2-.23.17-.36-.36.19-.38,0-.79-.22-.07,0,.53-.32.09.42.58-.31.2-.08.75l-.21-.22c0,.06.06.22,0,.26l-.2-.36c.11.38-.48.09-.47.35.26-.3.33.18.61.21,0,.64-.78-.33-1.05.18,0-.08.33-.08.36.1a.8.8,0,0,1-.46,0c-.2.31.27.17.3.41-.36-.16,0,.23,0,.43l-.23-.21c-.43.18.41.52,0,.64l-.22-.41-.05.22-.23-.27c.05.34,0,.34-.26.43.2.11.4.39.28.54-.22,0-.17-.25-.31,0-.1-.17-.24-.38.05-.28-.07-.07-.11-.17-.18-.25-.24,0-.26.22-.32.3a.16.16,0,0,1,.12,0l.07.57a.32.32,0,0,1-.21-.23c0,.08,0,.22,0,.32-.17-.19-.36-.36-.35-.56l0,.45c-.1-.05-.35-.06-.39-.16-.24.05,0,.69-.29.76a.21.21,0,0,1,0,.16c-.21.15-.59.1-.53.56l-.45-.18c-.08.24.58.21.45.61s-.36-.18-.52-.2c.08.26.27.74-.18.68C347.58,272.3,347.67,272.3,347.7,272.22Zm-1.78,2.25c0-.08-.08-.3.08-.21C346.22,274.55,346.06,274.47,345.92,274.47Zm-2.37,3.72c-.05-.1,0-.11.17-.08C343.7,278.16,343.66,278.2,343.55,278.19ZM337,288.61v0C337.18,288.58,337.11,288.58,337,288.61Zm-.27.1a.12.12,0,0,0,.08.09c0-.06,0-.11.05-.14S336.74,288.6,336.74,288.71Zm18.45-20.5h-.09C355.11,268.05,355.15,268.13,355.19,268.21Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.57,277.54l.14.1A.17.17,0,0,0,343.57,277.54Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.77,270.79h0l0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.46,284a.36.36,0,0,1,.18,0A.13.13,0,0,0,337.46,284Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.21,290.07l.05-.18c0,.07-.11.05-.17,0S336.24,290,336.21,290.07Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.82,289.84s0,0,0,.08l.11.09C334,289.93,333.94,289.8,333.82,289.84Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.34,289.49c-.2-.17-.2,0-.24.09v0C335.36,289.83,335.35,289.66,335.34,289.49Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.08,289.6a.15.15,0,0,1-.06.09C335.12,289.79,335.07,289.68,335.08,289.6Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.65,289.06c-.09,0,.22.25.12.2C337,289.53,336.72,288.73,336.65,289.06Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.64 288.98 334.91 289.17 334.76 288.95 334.64 288.98",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.43,288.47l-.19.07a.15.15,0,0,1,.05.11C335.37,288.58,335.5,288.53,335.43,288.47Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.29,288.65a.13.13,0,0,0-.06.15A.26.26,0,0,0,335.29,288.65Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.74 288.73 334.83 288.74 334.93 288.66 334.74 288.73",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.81,287l.06-.21c-.06-.09-.15-.09-.17,0S336.71,287,336.81,287Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.74,286.9a.68.68,0,0,1,.24.1l-.29-.27Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.07,286.41c-.07-.09,0-.43-.2-.23C335.94,286.27,335.87,286.48,336.07,286.41Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.48 284.5 338.45 284.55 338.94 284.98 338.48 284.5",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.11,281.48c-.28.07.26.31,0,.34.08.15.24,0,.3.11C339.35,281.71,339.47,281.72,339.11,281.48Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.38,281.93a.74.74,0,0,0,0,.12A.33.33,0,0,0,339.38,281.93Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.73 261.52 361.93 261.49 361.7 261.42 361.73 261.52",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.57,261l.33.26-.22-.32S361.65,261,361.57,261Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,274.22l.07.08c.09.06.12,0,.19,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.64 272.9 346.61 272.92 346.94 273.12 346.64 272.9",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.45,271.28c-.06.05-.05.16-.11.21C347.39,271.33,347.82,271.59,347.45,271.28Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63,294.92c.05.07.16-.11.2-.14C369.69,294.73,369.6,295,369.63,294.92Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.27 294.41 368.34 294.36 368.05 294.39 368.27 294.41",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.28,293.58c-.13.36.4.25.49.5l0,.09L368,294C367.77,293.87,367.37,293.78,367.28,293.58Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.25,292.53c-.06.14-.19,0,.09.14v-.05Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,292.62c.11.08,0-.15,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,292.28l.22,0c0-.09-.09-.21,0-.22C366.84,292,366.82,292.11,366.81,292.28Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,292.38l.1,0S366.62,292.33,366.52,292.38Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.84,292.43l-.22,0c0,.06-.09.15.1,0C366.64,292.49,366.73,292.44,366.84,292.43Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.89,292.55c0,.12.1.25-.12.23C367.07,293,367.19,292.73,366.89,292.55Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,293.83l0,.17.17,0C367.12,294,367.06,293.74,367,293.83Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.08,291.42c-.06.05-.09.2-.14.28l.16,0C366.08,291.63,366,291.51,366.08,291.42Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.94,291.7l-.23,0C365.83,291.8,365.9,291.78,365.94,291.7Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.24 292.67 366.66 292.66 366.19 292.63 366.24 292.67",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.5 290.93 365.7 290.86 365.38 290.94 365.5 290.93",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,290.63c.16-.06.07-.27.19-.28a.66.66,0,0,0-.44,0C365,290.35,365.06,290.44,365.1,290.63Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.61,290.34a1,1,0,0,0,.24,0A.4.4,0,0,0,364.61,290.34Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.47,291.43a.33.33,0,0,0,0-.27l-.07.22Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41,291.39h0l-.13-.12A.84.84,0,0,1,365.41,291.39Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.49,291.45l0,0S365.46,291.46,365.49,291.45Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,292.18c-.17,0-.44,0-.37.26C365.75,292.38,365.72,292.21,366,292.18Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.39,291.72l.13.17c0-.05.06-.14.14-.14Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.27 291.7 365.39 291.72 365.34 291.65 365.27 291.7",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.76,290.73a.39.39,0,0,1-.3-.1.91.91,0,0,0,.23.28C364.75,290.87,364.87,290.81,364.76,290.73Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.07,291.06h0S365.05,291.09,365.07,291.06Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.61,289.92v0l0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68,291c.05.09.12.08.2.06a.93.93,0,0,1-.19-.11S364.65,290.94,364.68,291Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.31,290.22a1.46,1.46,0,0,0,.05.2C364.37,290.33,364.36,290.19,364.31,290.22Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.06,291h0C365.08,290.94,365.07,291,365.06,291Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.06,291l-.18,0a.53.53,0,0,0,.16,0A.25.25,0,0,1,365.06,291Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.48,290.78a.26.26,0,0,1,.46.17c.25,0,.56-.59.66-1-.06.06-.11.13-.34.09,0,.13.19.49-.06.52s-.13-.2-.16-.37c-.07.27-.5.06-.69.38l.27.06C362.59,290.69,362.46,290.7,362.48,290.78Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.89,290.23l.08,0a.79.79,0,0,1-.05-.4.38.38,0,0,0-.29.07l.3.3Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.27,290.51c-.19.13-.41.07-.46.33.2.15.25,0,.42,0-.34-.22.17,0,0-.31a.59.59,0,0,1,.21.1,1,1,0,0,1-.1-.21h0s0,0,0,0h0l-.06.05c-.06-.11,0-.06.06-.05l0,0h0l-.39-.17A.81.81,0,0,0,364.27,290.51Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.14,292.67a.08.08,0,0,1,0-.05S365.1,292.63,365.14,292.67Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.09,292.46s.12-.06.18,0-.07.08-.11.14.25,0,.18-.19h0a.77.77,0,0,1,0-.51A1.81,1.81,0,0,0,365.09,292.46Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.63,291.52l-.32-.13v.25l.07-.09C364.5,291.71,364.56,291.57,364.63,291.52Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.65 289.81 363.83 289.66 363.48 289.79 363.65 289.81",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.3 289.55 363.44 289.4 363.27 289.42 363.3 289.55",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.77,275.59l-.11,0A.23.23,0,0,0,342.77,275.59Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,276.06l.07-.06C343.32,276,343.29,276,343.31,276.06Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,282.65c0-.24.07-.57-.06-.38l-.11.2A.22.22,0,0,1,355,282.65Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.55,278.93V279l.21-.1Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.9,279.57l-.06-.23A.78.78,0,0,0,347.9,279.57Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.62,273.25l-.23.1C339.53,273.47,339.54,273.33,339.62,273.25Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.8,286.73a.74.74,0,0,0-.15-.31C359.69,286.62,359.66,286.84,359.8,286.73Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.45,274a.15.15,0,0,0-.15.05C344.37,274,344.43,274,344.45,274Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.37,286.19a.29.29,0,0,1,0,.09.6.6,0,0,1,.26.14C359.62,286.28,359.56,286.15,359.37,286.19Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,264v0S328.82,264,328.83,264Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.06,259.59l.14.1A.35.35,0,0,0,327.06,259.59Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,288.34c.08.05,0,0,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.8,289.31a.12.12,0,0,0-.09.06S361.78,289.31,361.8,289.31Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.8,286.66Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.05,288.51a.5.5,0,0,0-.05-.13A.36.36,0,0,0,362.05,288.51Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.1,288.42l0,.06S362.19,288.44,362.1,288.42Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,288.27a.52.52,0,0,1,.1.11s0,0,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,268.41v0C334.91,268.4,335,268.41,335,268.41Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,282.87h0v0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.38,282.78c.28-.12.32,0,.37.07l.31-.56Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.41,274.54l.06.3c-.43.07-.51-.15-.52.21.46-.51.74.53,1.2,0l0,.21s-.06,0-.09,0c0,.45.48-.25.72.08.07.13.08.27,0,.27l.34.06a.06.06,0,1,1-.1.08l.39.25,0,0a1.91,1.91,0,0,1,.44-.09c0,.15-.09,0-.12.11l.3,0c0,.2-.3.2-.42.07-.25.69.27,0,.41.64l-.24-.08c-.13.4.1.41.16.77,0-.14,0-.82.29-.78,0,.09.09.18.29.16-.15.2,0,.24.14.35l-.21.24c.21.06.3-.08.48-.12.15.16,0,.39-.07.59.24.26.07-.47.43-.25.14.28.38.31.77.38.09.22-.15.13-.15.25l.3-.08s0,.08-.06.11c.18,0,.21-.24.45-.16.28-.23.05.72.53.6,0,.12-.15.13-.21.24a2,2,0,0,0,.87,0l.08.35c0-.32.38-.37.71-.41a2.67,2.67,0,0,0,0-.32l.4.1c0,.07-.1.13-.23.2l.1,0c0,.18-.14.28-.33.36a1.94,1.94,0,0,1,0-.24,1.28,1.28,0,0,0-.5.37.26.26,0,0,1,.15,0c-.05,0-.1.05-.11.09s.07,0,.16,0l-.16.34.11-.1.23.49a2.86,2.86,0,0,1,1.59,0c-.28.12-.3.32-.5.56.09-.36-.42-.17-.6-.4.1.12,0,.21-.09.23l.59.1c-.17.19,0,.22,0,.38.24-.46.5,0,.76,0-.1.14-.25.24-.42.05,0,.48.66-.23.67.2-.06,0-.06-.08-.14,0,.21,0,.41.3.25.36l0,0c.28.31,1,.81,1.28.52a6,6,0,0,1-.44.42l1.47-.66c-.28.25-.64,1.1-1,1a.37.37,0,0,0,.34.26c0-.08.21-.52.3-.49-.07.48,0,.28,0,.75,0-.12.43-.5.54-.38-.08.05-.35.45-.44.46l.66-.19c-.14,0-.31.36-.35.55,0-.12.26.22.38.25l-.05-.21c.29.35.84-.34,1.16,0-.11.05-.55.47-.43.67.27-.16,1.24-.79,1.68-.72l-.05.18.35,0a9.85,9.85,0,0,1-1.85.69c.05.21-.09.19.11.34,0,.17-.25.09-.31.05l.38.46c.2-.29.56,0,.72-.22l-.71-.13c.2-.28.89-.52,1.17-.21,0,.18-.44.43-.51.52.12-.06.44.08.42.17l-.25,0c.1.24.57-.12.58.31.06.08-.06.53.08.38a4.67,4.67,0,0,1,1.13-1.51,4.28,4.28,0,0,1,.11.83c-.07.33-.64.41-.7.7a.49.49,0,0,1,.25-.11c0,.13-.21.2,0,.3.24-.24.32.31.26-.16.23.06.13.2.33.35a1,1,0,0,1,.88-.38.57.57,0,0,0-.12.23c.32.31.4.58.71.84,0,.09.06.3-.1.36.09,0,.2-.07.3,0,0,.38-.24-.15-.33.25.14-.15.43,0,.64,0,.16-.28-.28-.31-.49-.33a1.24,1.24,0,0,1,1.24-.36c.32.13-.06.31,0,.3.44.46.88-.23,1.09.34,0,.35-.33.43-.42.61-.27-.09-.21-.4-.36-.51l.09.24c-.12,0-.31-.05-.33-.17,0,.3.79.72,1,1.21.13,0,.3,0,.31-.12l-.14-.07c0-.26.42,0,.33-.25.26,0,.59,0,.73.26l-.15.27c.05-.07,0-.26-.15-.24.18,0,.08.61.44.38l0-.3c.26,0,.67-.08.8.17.11-.32-.06,0,0-.41-.16.45-.5-.44-.59.09.11-.45-.14-.35-.11-.79-.06.09-.06.21-.19,0l-.09,0h0s0,0,0,0a.39.39,0,0,1,0,.19c-.23.12-.49-.11-.66-.09s.12-.06.13-.19l-.25,0c.13-.19,0-.51.29-.42l-.2-.19a.45.45,0,0,0-.35-.39c-.06-.13-.4,0-.21-.08l-.41-.17,0-.05c-.31-.29-.91-.26-1-.89a.73.73,0,0,1-.44-.3l.08-.18c-.18-.06-.29-.5-.48-.4.18-.53-.61-.66-.8-.94l-.17.2a1.53,1.53,0,0,0-.65-.33l-.13.18c-.29,0-.36-.51-.66-.74.07,0,.13,0,.15.11,0-.68-1-.31-1-.87a.17.17,0,0,1-.19-.16h0l0,0,0-.18a.81.81,0,0,0,0,.17.79.79,0,0,0-.29-.13l.11-.22,0,0c0-.14-.15,0-.21.22a.49.49,0,0,0-.21,0c.17-.36-.32-.09-.15-.5-.19.11-.55-.25-.87,0,0,0,0-.09.08-.05-.07-.12-.14-.24-.31-.22l.16-.28-.48.14c0-.25,0-.38.28-.46-.55,0-.34-.11-.84-.05l.14-.14c-.1-.08-.42,0-.38-.18,0-.47-1-.93-1.36-1.66-.26.54-.08-.43-.39-.09.05-.13,0-.26.19-.28-.37-.13-.28-.53-.72-.39.06-.13.19-.11.21-.19s-.16,0-.14-.07.11-.06.2-.07c-.31-.22-.61.09-.88.38,0-.27-.12-.31-.39-.19,0-.14,0-.32.25-.21-.09-.1-.5-.67-.71-.42,0-.09-.12-.14-.17-.13a2.94,2.94,0,0,0-.46-.41l0,.1c-.34.23-.24-.09-.45-.2l0,0c-.23-.56-.26,0-.46-.63l-.13.21c-.37.37-.17-.54-.53-.58v.17c-.24,0,.09-.85,0-1s.09,0,.15,0c-.14-.52-.24.21-.54.06.06-.17.34-.29.19-.46s-.84,0-.86-.42c0,.14-.07.29-.25.27s-.17-.8-.59-.61a.15.15,0,0,1,0-.1c-.2,0-.55-.24-.78-.13.41-.76-1.1-.39-.61-1l-.45-.32.06-.05a.53.53,0,0,0-.66-.14c0-.09.07-.11.1-.14-.3-.45-.36-.45-.93-.43l.13-.22c-.18,0-.32-.78-.89-.88a.16.16,0,0,1,.11,0c-.62-.13-.59-1.41-1.33-.83l-.43-.07c.33.37-.3.27-.24.51-.18-.08-.21-.53,0-.41v.06c.37-.32-.35-.52-.14-.76-.74-.59-1.28-1.39-1.95-2l-.15.35-.23-.21c0-.12.1-.3.26-.14,0-.24-.39-.1-.45-.05-.24-.39.4-.22.31-.32l-.16-.09v.06c-.21,0-.32.14-.52,0s.08-.24,0-.29,0,0-.07-.07l-.28-.28-.06.33c-.23,0-.28-.25-.35.12.12-.56-1-1.07-1-1.3a.9.9,0,0,1-.71-.36c0,.1-.16.38-.33.19.5-.47-.17-.53,0-1.05-.06.37-.61-.4-.68.14-.12-.18.15-.2.13-.43-.55-.12-.75-.85-1.29-1.19-.06.07-.06.24-.25.26l0-.56c-.13-.05-.42.32-.39-.06,0,.08-.06.2-.14.17-.67-1.13-2.15-1.34-2.59-2.78,0,.25-.08.19-.18.11,0,.09-.14.17-.21.27l-.18-.59c-.29.2-.45-.34-.69-.13l.16.06c-.41.15-.29.85-.62,1.21.46-.18.09.91.79.69,0,.14-.15.08-.19.19.21-.09.33-.05.45.17l0,0c.52.37.61.71,1.07,1.28l.11-.22a.49.49,0,0,1,.1.3c.36-.17-.32-.3.05-.51-.15.51.84.71.6,1.23.18.16.12-.26.3-.1l-.05.16.17-.12a.39.39,0,0,1,0,.43s-.11,0-.15-.06c.05.27.48.32.5.41l-.12-.22c.59.31,1.08,1,1.75,1.14l0-.12c.5.15.21.35.68.61h0a.48.48,0,0,1,.4.13c-.19,0,0,.36-.2.37.54.16.31,0,.84-.08l-.06.19c.2-.05.26-.12.5,0-.27,0-.05.33-.37.34.16.67.89.2.7.83.53-.24-.18-.53,0-.52,0-.21.4-.17.5,0s-.18.71.16,1c0,0-.06,0-.09,0,.05.21.36.07.39.37.28-.17.19.18.47-.11l-.38-.19c.25.07.71-.16.86.26a.61.61,0,0,1-.33.05c0,.17.22.08.23.25-.28.29-.44-.25-.82-.17,0,.21.54.07.17.33.49-.31.3.34.79.2l-.16.18c.06,0,.21,0,.27,0l-.32.15c.35-.05.21.48.49.52-.39-.31.09-.3,0-.57.67.14-.12.71.47,1.06-.09,0-.18-.33,0-.33a.87.87,0,0,1,.13.45c.37.25.1-.23.34-.23-.07.33.24.05.45.1l-.15.2c.29.45.42-.31.66.13l-.37.14.24.08-.21.19c.33,0,.36.1.51.32a.33.33,0,0,1,.48-.18c0,.21-.21.13.05.3-.15.08-.33.18-.29-.09a1.59,1.59,0,0,0-.22.13c0,.23.3.29.39.37a.22.22,0,0,1-.06-.13l.57,0c0,.12-.09.14-.18.15.09,0,.21,0,.33.07-.16.13-.28.3-.49.25l.48.11c0,.08,0,.33-.06.35.11.25.7.09.85.42a.21.21,0,0,1,.16,0c.21.23.26.6.71.62l-.07.41c.27.12.07-.53.52-.33s-.1.32-.07.47c.24,0,.7-.13.75.29C341.53,274.67,341.5,274.58,341.41,274.54Zm2.79,2.12c-.09,0-.29,0-.24-.11C344.2,276.38,344.16,276.53,344.2,276.66Zm4.45,3c-.09,0-.12-.05-.13-.18A.24.24,0,0,1,348.65,279.63Zm12.45,8.21h0C361,287.67,361.05,287.74,361.1,287.84Zm.17.28a.08.08,0,0,0,.08-.06c-.06,0-.11,0-.16-.08S361.17,288.11,361.27,288.12ZM335.32,266.5v.09C335.17,266.55,335.24,266.53,335.32,266.5Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,279.5a.34.34,0,0,1,.06-.12C348,279.39,348,279.43,348,279.5Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.66,273.23h0l0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.23,286.61a.38.38,0,0,1,0-.18S356.17,286.53,356.23,286.61Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.81,288.87l-.19-.08c.08.06.07.12.09.18S362.76,288.84,362.81,288.87Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.2,291.17s.05,0,.09,0l.07-.1C363.26,291,363.13,291.05,363.2,291.17Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.44,289.62c-.11.17,0,.2.16.26h0C362.79,289.67,362.62,289.65,362.44,289.62Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.63,289.9a.2.2,0,0,1,.1.08C362.82,289.9,362.71,289.93,362.63,289.9Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.66,288.28c0,.08.2-.18.18-.09C362.06,288,361.3,288.15,361.66,288.28Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.11 290.23 362.23 290 362.04 290.1 362.11 290.23",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.37,289.36l.13.2s.06,0,.1,0S361.41,289.3,361.37,289.36Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.6,289.53a.19.19,0,0,0,.16.09A.76.76,0,0,0,361.6,289.53Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.82 290.09 361.8 290 361.69 289.88 361.82 290.09",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.54,287.77l-.23-.1c-.08.05-.06.13,0,.16S359.52,287.86,359.54,287.77Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.67,288.79a.57.57,0,0,1,0-.22l-.2.24Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.08,288.38c-.08.06-.43,0-.18.15C359,288.48,359.21,288.58,359.08,288.38Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.49 285.69 356.54 285.73 356.85 285.32 356.49 285.69",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2,284.55c.15.28.26-.2.36.09.13-.05-.09-.24,0-.28C353.38,284.35,353.35,284.24,353.2,284.55Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.59,284.36h0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.7 258.94 326.63 258.73 326.61 258.94 326.7 258.94",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.19,259l.17-.28-.27.16S326.21,258.92,326.19,259Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.18,277.51l.06-.05c0-.08,0-.12-.06-.18Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.38 275.69 342.41 275.72 342.54 275.44 342.38 275.69",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.51,274.61c.06.07.18.08.24.15C340.57,274.68,340.72,274.31,340.51,274.61Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.92,208.26c-.06,0,.15.19.18.23C443.14,208.37,442.87,208.21,442.92,208.26Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.22 207.01 443.29 207.1 443.2 206.8 443.22 207.01",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.93,206.24c-.4-.24-.2.33-.44.36l-.1,0,.22.31C443.72,206.65,443.73,206.27,443.93,206.24Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.05,206.49c-.16-.1,0-.2-.13.06H445A.3.3,0,0,1,445.05,206.49Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,206.56c-.06.09.16.05,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.24,206.11l0,.22c.1,0,.2,0,.23,0C445.52,206.21,445.43,206.17,445.24,206.11Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.08,205.79v.1S445.15,205.9,445.08,205.79Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.08,206.1v-.21c-.07,0-.18-.14,0,.09C445,205.87,445.05,206,445.08,206.1Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,206.12c-.13,0-.25,0-.27-.18C444.56,206.19,444.83,206.37,445,206.12Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.62,205.88h-.18l.06.17C443.47,206,443.73,206,443.62,205.88Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,205.6c-.07-.07-.23-.14-.33-.22v.16A.43.43,0,0,1,446,205.6Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.7,205.38l0-.23C445.57,205.25,445.61,205.32,445.7,205.38Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.72 205.43 444.81 205.86 444.75 205.38 444.72 205.43",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.45 205.15 446.56 205.37 446.41 205.02 446.45 205.15",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.7,204.82c.09.18.3.14.33.27a.71.71,0,0,0,0-.44C447,204.77,446.9,204.83,446.7,204.82Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.92,204.4a.9.9,0,0,0,.06.25A.79.79,0,0,0,446.92,204.4Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.91,205a.42.42,0,0,0,.29.09l-.25-.13Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.94,204.93h0l.11-.09Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.89,205h0S445.87,205,445.89,205Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.19,205.28c-.05-.17,0-.43-.34-.45C444.94,205,445.12,205,445.19,205.28Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.59,204.82l-.17.09c.06,0,.16.09.18.18Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.58 204.7 445.59 204.82 445.65 204.79 445.58 204.7",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.53,204.45a.31.31,0,0,1,.05-.28.63.63,0,0,0-.26.16C446.38,204.4,446.46,204.53,446.53,204.45Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.23,204.67a0,0,0,0,1,0,0S446.19,204.64,446.23,204.67Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.19,203.5l-.05,0,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.27,204.31c-.09,0-.07.1,0,.18a.48.48,0,0,1,.08-.16S446.28,204.28,446.27,204.31Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,204.13h-.2C446.88,204.16,447,204.19,447,204.13Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.3,204.68h0C446.36,204.72,446.34,204.7,446.3,204.68Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.3,204.68c0-.06,0-.12-.06-.19a.42.42,0,0,0,0,.16Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.06,202.12c.18.18.23.48-.09.42,0,.25.73.73,1.17.94a.43.43,0,0,1-.15-.37c-.14-.05-.49.06-.57-.2s.19-.08.36-.07c-.29-.14-.15-.52-.53-.8v.26C446.19,202.25,446.15,202.12,446.06,202.12Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.91,203.7l0,.07a.81.81,0,0,1,.42.06.53.53,0,0,0-.12-.32l-.26.23Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.67,204c-.17-.23-.14-.43-.43-.56-.13.17.07.26.08.43.17-.29.05.18.33.11a.42.42,0,0,1-.07.18.78.78,0,0,1,.21,0h0s0,0,0,0h0l-.07-.08c.11,0,.07,0,.07.08l0,0h0l.11-.35C446.81,203.8,446.75,203.87,446.67,204Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.52,204.3s0,0,.06,0S444.56,204.28,444.52,204.3Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.74,204.31c0,.05.08.14,0,.18s-.1-.09-.17-.15,0,.25.24.23l0,0a1.05,1.05,0,0,1,.55.11A4,4,0,0,0,444.74,204.31Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.66,204.11l.08-.3-.27-.06.11.1C445.44,203.92,445.59,204,445.66,204.11Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.31 203.57 447.51 203.79 447.31 203.4 447.31 203.57",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.53 203.28 447.71 203.46 447.66 203.29 447.53 203.28",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.76,186.22v0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.36,186.64l.08.1C458.41,186.67,458.38,186.63,458.36,186.64Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.42,196.76c.26.07.62.22.4,0l-.24-.16C453.57,196.73,453.5,196.76,453.42,196.76Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.23,191.19l-.09,0,.15.23Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.43,190.35h.23A.58.58,0,0,0,455.43,190.35Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.7,183.65l-.15-.26C460.45,183.5,460.6,183.55,460.7,183.65Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.92,200.5a.47.47,0,0,0,.29-.07C450,200.41,449.77,200.32,449.92,200.5Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.81,188.37a.19.19,0,0,0-.08-.16A.16.16,0,0,0,460.81,188.37Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.41,200.21h-.08a.35.35,0,0,1-.12.23C450.36,200.44,450.49,200.41,450.41,200.21Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.67,175.22h.05S468.68,175.2,468.67,175.22Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,174.6a.28.28,0,0,1-.08.12S473,174.68,473,174.6Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.59,202.3c0,.07,0,0,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.52,201.83a.33.33,0,0,0-.08-.11Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.63,198.48Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.42,202.3l.12,0A.35.35,0,0,0,448.42,202.3Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.53,202.37l-.07,0S448.52,202.46,448.53,202.37Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.65,202.21a.19.19,0,0,1-.11.07.06.06,0,0,1,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.05,180.32h0C465,180.19,465,180.23,465.05,180.32Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.59,193.35a0,0,0,0,0,0,0h0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.62,193c.18.32.11.34,0,.36l.66.47Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.65,185.13l-.32,0c-.15-.45.07-.47-.31-.58.63.61-.44.61.19,1.22l-.22,0s0-.06,0-.08c-.48-.1.35.56,0,.71-.12,0-.27,0-.3-.12v.33c-.06,0-.16-.08-.1-.12l-.2.33,0,0a3,3,0,0,1,.17.46c-.16,0,0-.09-.13-.15v.3c-.22-.09-.27-.37-.15-.45-.78-.44.05.27-.61.24l0-.22c-.46-.24-.42,0-.8,0,.15.07.87.2.88.51-.09,0-.17,0-.12.25-.23-.21-.25-.07-.34.05l-.3-.28c0,.2.15.33.22.52-.15.11-.41-.08-.64-.23-.24.17.51.2.34.5-.27.07-.26.31-.27.69-.22,0-.17-.19-.3-.23l.15.33s-.1,0-.13-.09c0,.17.3.28.25.5.3.34-.76-.15-.54.38-.13,0-.17-.19-.3-.29a2.21,2.21,0,0,0,.14.89h-.36c.35.08.47.48.57.83l.35.12,0,.37c-.07,0-.16-.13-.25-.29l0,.11c-.18,0-.32-.22-.44-.43a1.34,1.34,0,0,1,.26.09,2.14,2.14,0,0,0-.48-.62.27.27,0,0,1,0,.15.38.38,0,0,0-.12-.13s0,.07.06.17l-.39-.25.12.13-.48.1c.15.53.49,1.16.33,1.63-.18-.31-.4-.39-.69-.66.4.19.1-.38.33-.5-.12.06-.24-.08-.27-.15v.57c-.23-.23-.24-.1-.41-.11.53.37.11.52.14.78-.17-.14-.31-.32-.13-.44-.51-.15.37.73-.09.62,0,0,.07,0,0-.13a.19.19,0,0,1-.34.15l0,0c-.28.2-.69.76-.32,1.16a7.28,7.28,0,0,1-.52-.56l1,1.68c-.31-.36-1.28-1-1.29-1.34-.11,0-.23,0-.22.27.08,0,.6.36.58.44a2.87,2.87,0,0,0-.81-.19c.13,0,.62.56.51.65-.07-.09-.55-.48-.57-.57l.32.72a1.56,1.56,0,0,0-.65-.5c.13.07-.19.2-.2.31h.22c-.33.2.51,1,.24,1.19-.08-.13-.61-.7-.8-.62a6.37,6.37,0,0,1,1.07,1.9l-.2-.1v.34a15.69,15.69,0,0,1-1.07-2.07c-.22,0-.21-.14-.34,0a.24.24,0,0,1-.11-.34l-.42.27c.34.27.08.56.36.79v-.69c.34.28.71,1,.43,1.24-.18,0-.53-.56-.64-.65.08.13,0,.43-.1.38l-.08-.26c-.25,0,.22.61-.24.5-.07,0-.57-.2-.39,0a9.22,9.22,0,0,1,1.83,1.55,3.32,3.32,0,0,1-.87-.11c-.37-.16-.56-.76-.88-.9a.63.63,0,0,1,.16.28c-.13,0-.25-.27-.33-.1.31.32-.27.24.22.31,0,.21-.19.08-.31.24a1.66,1.66,0,0,1,.57,1,1.23,1.23,0,0,0-.27-.19c-.27.24-.55.25-.77.49-.1-.05-.31,0-.4-.19,0,.09.11.22,0,.3-.41-.1.11-.21-.33-.4.18.18.09.43.11.65.32.23.28-.2.26-.42a1.79,1.79,0,0,1,.61,1.36c-.09.29-.34-.15-.32-.06-.42.32.41,1-.17,1-.37-.11-.52-.46-.73-.6.06-.25.4-.1.49-.23l-.25,0c0-.13,0-.3.13-.29-.33-.1-.63.61-1.11.71,0,.13,0,.3.18.35l.05-.12c.29.1.13.43.33.4,0,.26.14.6-.14.68l-.33-.24c.09.08.28.05.24-.08.06.19-.64-.09-.33.34l.31.06c0,.25.21.69,0,.76.36.19,0-.06.44.13-.51-.28.38-.38-.2-.63.5.24.35,0,.82.11-.1-.08-.24-.12-.07-.2,0,0,0-.08-.06-.11h0s0,0,0,0a.42.42,0,0,1-.21-.06c-.16-.27,0-.47,0-.64.11,0,.08.13.22.18l-.07-.26c.22.18.54.11.5.41l.16-.16c.21,0,.38-.08.36-.24s-.06-.41.05-.19l.1-.38.06,0c.26-.23.12-.84.78-.79a.39.39,0,0,1,.23-.37l.21.14c0-.17.49-.17.34-.39.6.33.59-.44.86-.55l-.24-.23a.94.94,0,0,0,.24-.56l-.22-.19c-.05-.3.48-.23.67-.47.06.09,0,.12-.1.12.73.17.17-.89.75-.82,0-.13,0-.15.13-.14v0l0,0,.19,0a.47.47,0,0,0-.18,0,.57.57,0,0,0,.09-.27l.25.18v0c.15,0-.06-.16-.26-.28a1,1,0,0,0-.06-.22c.42.28,0-.29.51,0-.15-.22.18-.49-.2-.89.06.05.1.05.07.09.12,0,.24-.07.18-.25l.33.23-.24-.52a.62.62,0,0,1,.55.41c-.12-.56,0-.32-.1-.84l.18.18c.06-.08-.08-.43.11-.33.52.15.81-.8,1.54-.93-.63-.42.44,0,0-.38.16.09.29.1.34.27.07-.34.51-.15.28-.63.16.1.15.23.25.27s0-.17.05-.12.08.13.11.22c.18-.25-.2-.64-.57-1,.28.05.31,0,.14-.34.16.07.35.12.26.3.09-.06.63-.31.33-.6.1.05.12-.09.11-.14.18-.16.22-.15.35-.35h-.1c-.3-.4.05-.22.14-.4l0,0c.56-.08,0-.26.59-.3l-.24-.19c-.47-.47.54,0,.52-.37l-.19-.06c-.08-.25.93.33,1.08.28s0,.1,0,.16c.53,0-.27-.31-.16-.57.2.11.37.42.52.31.19.06-.17-.85.3-.76-.16-.07-.32-.14-.33-.32s.82,0,.54-.43a.23.23,0,0,1,.12.06c0-.2.15-.5,0-.76.88.61.22-1,.95-.36l.26-.36.06.07c.24-.16.14-.4,0-.63.09,0,.13.1.16.13.43-.17.43-.23.3-.82l.26.19c-.07-.2.78-.11.78-.67a.4.4,0,0,1,.07.13c0-.59,1.4-.22.65-1.12v-.42c-.34.23-.34-.38-.59-.39,0-.16.53-.06.44.12l-.06,0c.4.46.49-.21.79.07.5-.59,1.25-.93,1.76-1.45l-.41-.25.19-.17c.13,0,.34.18.2.3.26.11,0-.37,0-.44.37-.14.31.47.39.39l.07-.13h-.06c-.06-.22-.21-.36,0-.51s.26.14.31.12.05,0,.07-.06l.24-.2-.36-.16c0-.23.21-.21-.2-.38.63.27,1-.72,1.21-.69a.56.56,0,0,1,.26-.62c-.1,0-.44-.26-.26-.38.59.63.54,0,1.11.26-.41-.17.33-.51-.27-.73.17-.08.25.21.49.25,0-.53.77-.53,1-1-.07-.08-.26-.13-.31-.32l.6.18c0-.12-.42-.51,0-.38-.08-.05-.22-.12-.2-.19,1.09-.37,1-1.82,2.5-1.88-.26,0-.21-.13-.15-.21s-.2-.19-.33-.28l.61,0c-.27-.34.28-.36,0-.67l0,.15c-.23-.45-1-.52-1.4-1,.27.52-1-.15-.6.62-.14,0-.1-.18-.24-.24.14.23.12.35-.1.41l0-.06c-.31.43-.65.42-1.18.74l.26.17a.4.4,0,0,1-.3,0c.24.42.26-.25.55.19-.58-.29-.61.66-1.21.27-.14.14.3.19.16.34l-.17-.09.15.2c-.12.06-.34-.05-.46-.15,0,0,0-.1,0-.13-.28,0-.25.4-.35.39l.22-.06c-.23.51-.85.83-.91,1.47l.13.07c-.06.46-.33.12-.53.52v0a.34.34,0,0,1-.07.37c0-.19-.38-.07-.42-.3-.08.51,0,.31.23.87l-.22-.11c.1.22.18.3.08.5,0-.27-.37-.14-.43-.47-.7,0-.06.85-.77.49.35.6.53,0,.56.14.23.07.25.46.11.52s-.8-.39-1-.11c0,0,0-.06,0-.08-.22,0,0,.35-.33.29.24.33-.16.14.2.5l.14-.32c0,.23.29.76-.13.79a.8.8,0,0,1-.11-.34c-.18,0-.05.2-.23.16-.36-.36.19-.37,0-.78-.22-.07,0,.53-.32.09.42.57-.31.2-.08.74l-.21-.21c0,.06.06.21,0,.26l-.21-.36c.12.37-.48.09-.47.35.26-.3.33.18.61.2,0,.64-.78-.32-1.05.19,0-.09.33-.09.36.09a.72.72,0,0,1-.46,0c-.2.32.27.17.3.41-.36-.15,0,.24,0,.44l-.23-.21c-.43.18.41.51,0,.63l-.22-.4,0,.22-.23-.27c.05.33,0,.34-.26.42.2.11.4.4.29.54-.23,0-.18-.25-.32,0-.1-.18-.24-.39.05-.28-.07-.08-.11-.17-.17-.25-.25,0-.27.22-.33.29a.12.12,0,0,1,.12,0l.07.56c-.13,0-.17-.13-.21-.22,0,.08.05.21,0,.31-.17-.19-.36-.36-.35-.55l0,.45c-.1,0-.35-.06-.39-.16-.24.05,0,.69-.29.76a.2.2,0,0,1,0,.16c-.21.14-.59.1-.53.55l-.45-.18c-.08.24.58.22.45.62s-.36-.19-.52-.2c.08.25.27.74-.18.68C459.53,185.21,459.62,185.21,459.65,185.13Zm-1.78,2.25c0-.09-.08-.3.08-.21C458.17,187.46,458,187.38,457.87,187.38Zm-2.37,3.72c-.05-.1,0-.11.17-.09C455.65,191.07,455.61,191.1,455.5,191.1ZM449,201.51h0C449.13,201.49,449.06,201.49,449,201.51Zm-.27.1a.14.14,0,0,0,.08.1c0-.07,0-.11.05-.15S448.69,201.51,448.69,201.61Zm18.45-20.49-.09,0C467.06,181,467.1,181,467.14,181.12Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.52,190.45a1.1,1.1,0,0,1,.14.09A.15.15,0,0,0,455.52,190.45Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.72,183.7h0l0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.41,196.91a.28.28,0,0,1,.18,0A.13.13,0,0,0,449.41,196.91Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.16,203l0-.17c0,.07-.11,0-.17,0S448.19,202.93,448.16,203Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.78,202.74s0,0,0,.09l.11.09C445.93,202.84,445.89,202.71,445.78,202.74Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.29,202.4c-.2-.17-.2,0-.24.08h0C447.31,202.74,447.3,202.57,447.29,202.4Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,202.51s0,.07-.07.08S447,202.58,447,202.51Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.6,202c-.09,0,.22.25.12.2C448.93,202.44,448.67,201.63,448.6,202Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.59 201.89 446.86 202.07 446.71 201.85 446.59 201.89",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.38,201.37l-.19.08a.13.13,0,0,1,.05.11C447.32,201.48,447.45,201.43,447.38,201.37Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.24,201.56a.13.13,0,0,0-.06.15A.3.3,0,0,0,447.24,201.56Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.69 201.64 446.78 201.64 446.88 201.56 446.69 201.64",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.76,200l.06-.21c-.06-.09-.15-.09-.17,0S448.66,199.9,448.76,200Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.69,199.81c.09,0,.14.05.24.1l-.29-.27Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,199.31c-.07-.09,0-.43-.2-.22C447.89,199.18,447.83,199.39,448,199.31Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.43 197.41 450.4 197.45 450.89 197.88 450.43 197.41",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.06,194.39c-.28.07.26.31,0,.34.08.14.24,0,.3.11C451.3,194.62,451.42,194.63,451.06,194.39Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.33,194.84a.74.74,0,0,0,0,.12A.29.29,0,0,0,451.33,194.84Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.68 174.42 473.88 174.4 473.65 174.33 473.68 174.42",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.52,173.88l.33.25-.22-.32S473.6,173.92,473.52,173.88Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,187.13l.07.08c.09,0,.12,0,.19,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.59 185.8 458.56 185.82 458.88 186.03 458.59 185.8",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.4,184.19c-.06,0,0,.16-.11.2C459.34,184.23,459.77,184.49,459.4,184.19Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.58,207.83c.05.07.16-.12.2-.14C481.64,207.64,481.55,207.87,481.58,207.83Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.22 207.32 480.29 207.27 480 207.3 480.22 207.32",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.23,206.49c-.13.36.4.25.49.5l0,.09.26-.16C479.72,206.77,479.32,206.69,479.23,206.49Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.2,205.44c-.06.13-.19,0,.09.13v0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.29,205.53c.12.08,0-.15,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.76,205.19H479c0-.08-.09-.2,0-.21C478.79,204.93,478.77,205,478.76,205.19Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.47,205.28l.1,0S478.57,205.24,478.47,205.28Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.79,205.34l-.22,0c0,.06-.09.16.1,0C478.59,205.4,478.68,205.35,478.79,205.34Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.84,205.45c0,.13.1.25-.12.23C479,205.87,479.14,205.64,478.84,205.45Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,206.74l0,.16.17,0C479.07,206.89,479,206.64,479,206.74Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478,204.33c-.06,0-.09.19-.14.28h.16C478,204.54,478,204.42,478,204.33Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.89,204.61l-.23,0C477.78,204.71,477.85,204.68,477.89,204.61Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.19 205.57 478.61 205.57 478.14 205.54 478.19 205.57",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.45 203.83 477.65 203.77 477.33 203.85 477.45 203.83",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.05,203.53c.16-.06.07-.26.19-.28a.8.8,0,0,0-.44,0C476.93,203.25,477,203.34,477.05,203.53Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.56,203.25a1.06,1.06,0,0,0,.24,0A.53.53,0,0,0,476.56,203.25Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.42,204.34a.34.34,0,0,0,0-.27l-.07.22Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.36,204.29h0l-.13-.12Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.44,204.35h0S477.41,204.37,477.44,204.35Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.92,205.09c-.17,0-.44,0-.37.26C477.7,205.29,477.67,205.12,477.92,205.09Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.34,204.62l.13.18c0-.05.06-.14.14-.15Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.22 204.61 477.34 204.62 477.29 204.56 477.22 204.61",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.71,203.64a.44.44,0,0,1-.3-.11,1.09,1.09,0,0,0,.23.29C476.7,203.78,476.82,203.71,476.71,203.64Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,204h0S477,204,477,204Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.56,202.82s0,0,0,.05l0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.63,203.86a.15.15,0,0,0,.2.07.93.93,0,0,1-.19-.11S476.6,203.85,476.63,203.86Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.26,203.13a1.33,1.33,0,0,0,.05.19C476.32,203.24,476.31,203.1,476.26,203.13Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,203.9h0C477,203.85,477,203.87,477,203.9Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,203.9a.57.57,0,0,0-.18,0l.16,0A.19.19,0,0,1,477,203.9Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.43,203.69a.26.26,0,0,1,.46.16c.25,0,.56-.58.66-1-.06.06-.11.12-.34.08,0,.13.19.5-.06.53s-.13-.2-.16-.37c-.07.26-.5.06-.69.38l.27,0C474.54,203.59,474.41,203.61,474.43,203.69Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.84,203.14l.08,0a.84.84,0,0,1-.05-.4.31.31,0,0,0-.29.07l.3.29Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.22,203.42c-.19.12-.41.06-.46.33.2.15.25,0,.42,0-.34-.22.17,0,0-.3a.83.83,0,0,1,.21.09.68.68,0,0,1-.1-.21v0h0s0,0,0,0h0l-.06.06c-.06-.11,0-.06.06-.06l0,0h0l-.39-.17A1,1,0,0,0,476.22,203.42Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.09,205.58a.06.06,0,0,1,0-.05S477.05,205.54,477.09,205.58Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,205.37s.12-.06.18,0-.07.08-.11.14.25,0,.18-.19h0a.76.76,0,0,1,0-.51A1.81,1.81,0,0,0,477,205.37Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.58,204.43l-.32-.14v.26l.07-.09C476.46,204.62,476.51,204.48,476.58,204.43Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.6 202.72 475.78 202.56 475.43 202.69 475.6 202.72",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.25 202.45 475.39 202.31 475.22 202.33 475.25 202.45",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.72,188.5l-.11,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.26,189l.08-.07C455.28,188.92,455.24,189,455.26,189Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,195.55c0-.23.07-.56-.06-.38l-.11.2A.25.25,0,0,1,467,195.55Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.5,191.84a.25.25,0,0,1,0,.08l.21-.1Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.85,192.48l-.06-.23A.87.87,0,0,0,459.85,192.48Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.57,186.16l-.23.1C451.48,186.37,451.49,186.24,451.57,186.16Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.75,199.63a.7.7,0,0,0-.15-.3C471.64,199.52,471.61,199.75,471.75,199.63Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.4,186.86a.15.15,0,0,0-.15,0C456.33,186.92,456.38,186.91,456.4,186.86Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.32,199.1a.24.24,0,0,1,0,.08.63.63,0,0,1,.26.15C471.57,199.19,471.51,199.06,471.32,199.1Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.79,176.89a.09.09,0,0,1,0,0S440.77,176.88,440.79,176.89Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,172.5l.14.1A.23.23,0,0,0,439,172.5Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,201.25c.08.05,0,0,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.75,202.21a.16.16,0,0,0-.09.06Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.75,199.57h0C469.74,199.61,469.74,199.6,469.75,199.57Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,201.41a.61.61,0,0,0-.05-.12A.42.42,0,0,0,474,201.41Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.05,201.32l.05.07S474.14,201.34,474.05,201.32Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.85,201.17a.4.4,0,0,1,.1.12s0,0,0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,181.32v0C446.86,181.3,446.9,181.32,447,181.32Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.69,195.78h0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.33,195.69c.28-.12.32,0,.37.07l.31-.56Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.36,187.44l.06.31c-.43.07-.51-.15-.52.21.46-.52.75.53,1.2,0l0,.21s-.06,0-.09,0c0,.45.48-.24.72.09.07.12.08.26,0,.27l.34.06c.05.06,0,.14-.1.08l.39.25h0a2.31,2.31,0,0,1,.43-.08c0,.15-.09,0-.12.1l.3,0c0,.2-.3.2-.42.07-.25.68.27,0,.41.64l-.24-.09c-.13.41.11.42.16.78,0-.14,0-.83.29-.78,0,.09.09.17.29.16-.15.19,0,.24.14.35l-.21.24c.21,0,.3-.09.48-.12.15.16,0,.39-.07.58.24.27.07-.47.43-.25.14.29.38.32.77.39.09.22-.15.13-.15.25l.3-.09s0,.09-.06.12c.18,0,.21-.25.45-.16.28-.24.05.72.53.6,0,.11-.15.13-.21.24a2.31,2.31,0,0,0,.87,0l.08.35c0-.33.38-.38.71-.41a2.63,2.63,0,0,0,0-.33l.4.11c0,.07-.1.13-.23.2l.1,0c0,.18-.14.28-.33.36a1.94,1.94,0,0,1,0-.24,1.19,1.19,0,0,0-.5.37.2.2,0,0,1,.15,0c-.05,0-.1,0-.11.08s.07,0,.16,0l-.16.34.11-.1.23.49a2.86,2.86,0,0,1,1.59,0c-.28.12-.3.32-.5.56.09-.36-.42-.17-.6-.41a.15.15,0,0,1-.09.24l.59.09c-.17.19,0,.22,0,.39.24-.46.5,0,.76,0-.1.14-.25.24-.42,0,0,.48.66-.23.67.2-.05,0-.06-.07-.14,0,.21,0,.41.29.25.36l-.05,0c.28.31,1,.81,1.28.51a4.47,4.47,0,0,1-.44.42l1.47-.65c-.28.25-.64,1.09-1,1a.39.39,0,0,0,.34.27c0-.09.21-.53.3-.49-.07.48,0,.28,0,.75,0-.13.43-.5.54-.39-.08.05-.35.46-.44.47l.67-.19c-.14,0-.32.36-.36.54,0-.11.26.23.38.25l-.05-.21c.29.36.84-.34,1.16,0-.11.06-.55.48-.43.68.27-.16,1.24-.8,1.68-.72l-.05.18.35,0a9.89,9.89,0,0,1-1.85.7c.05.21-.09.18.12.33,0,.18-.26.1-.32.06l.38.45c.2-.28.56,0,.72-.21l-.71-.13c.2-.29.89-.52,1.17-.21,0,.17-.44.42-.51.52.12-.06.45.07.42.16l-.25,0c.1.25.57-.11.58.32.06.08-.06.53.08.38a4.72,4.72,0,0,1,1.13-1.52,3.61,3.61,0,0,1,.11.83c-.07.34-.64.42-.7.7a.47.47,0,0,1,.25-.1c0,.12-.21.19,0,.3.25-.24.32.31.26-.16.23.06.13.2.33.35a1,1,0,0,1,.88-.39.54.54,0,0,0-.12.24c.32.3.4.58.71.84,0,.09.06.29-.1.35.09,0,.2-.06.3,0,0,.39-.24-.14-.33.26.14-.15.43,0,.64,0,.16-.28-.28-.31-.49-.33a1.24,1.24,0,0,1,1.24-.36c.32.13-.06.31,0,.3.44.46.88-.24,1.09.34,0,.35-.33.43-.42.61-.27-.1-.21-.41-.36-.52l.09.25c-.12,0-.31-.05-.33-.17,0,.3.79.72,1,1.21.13,0,.3,0,.31-.12l-.14-.07c0-.26.42-.05.33-.26.26,0,.59,0,.73.26l-.15.28c0-.08,0-.27-.15-.25.18,0,.08.62.44.39l0-.3c.26,0,.67-.08.8.16.11-.31-.06,0,0-.41-.16.45-.49-.44-.59.09.11-.44-.14-.34-.11-.78-.06.09-.06.21-.19,0l-.09,0v0s0,0,0,0a.4.4,0,0,1,0,.19c-.23.11-.49-.11-.66-.1s.12-.05.13-.18l-.25,0c.13-.19,0-.52.29-.43l-.2-.18a.48.48,0,0,0-.34-.4c-.07-.12-.41,0-.21-.08l-.42-.16,0,0c-.31-.29-.91-.27-1-.9a.75.75,0,0,1-.44-.29l.08-.18c-.18-.07-.29-.51-.48-.4.18-.54-.61-.66-.8-.94l-.17.19a1.8,1.8,0,0,0-.65-.33l-.13.19c-.29,0-.36-.52-.66-.74.07-.05.13,0,.15.11,0-.69-1-.32-1-.87a.17.17,0,0,1-.19-.16h0s0,0,0,0a1.48,1.48,0,0,0,0-.19.92.92,0,0,0,0,.18.78.78,0,0,0-.29-.14l.11-.22h0c0-.14-.14,0-.21.21a.71.71,0,0,0-.21,0c.17-.37-.32-.09-.15-.5-.19.11-.55-.26-.87,0,0,0,0-.09.08,0-.07-.12-.14-.24-.31-.23l.16-.27-.48.14c0-.26,0-.39.28-.46-.55,0-.34-.11-.84,0l.14-.15c-.1-.07-.42,0-.38-.17,0-.48-1-.93-1.36-1.67-.26.55-.08-.42-.39-.08.05-.14,0-.26.19-.28-.37-.13-.28-.53-.72-.39.06-.14.19-.11.21-.2s-.16,0-.14-.07.11,0,.2-.07c-.3-.22-.6.09-.88.39,0-.27-.11-.31-.39-.19,0-.15,0-.33.25-.21-.09-.1-.5-.67-.71-.43,0-.09-.12-.13-.17-.13a2.87,2.87,0,0,0-.46-.4l0,.09c-.33.23-.24-.08-.45-.2l0,0c-.23-.57-.26-.05-.46-.63l-.13.2c-.37.38-.17-.54-.53-.58v.18c-.24,0,.09-.85,0-1s.09,0,.15,0c-.14-.53-.24.21-.54.06.07-.18.34-.29.19-.46s-.84,0-.86-.43c0,.15-.07.29-.25.27s-.17-.79-.59-.6a.18.18,0,0,1,0-.11c-.2,0-.55-.23-.78-.12.41-.76-1.1-.4-.61-1l-.45-.32.06-.05a.53.53,0,0,0-.66-.13c0-.09.07-.11.1-.14-.3-.45-.36-.46-.93-.43l.13-.23c-.18,0-.32-.78-.89-.87a.16.16,0,0,1,.11-.05c-.62-.14-.59-1.41-1.33-.83l-.43-.07c.33.37-.3.26-.24.51-.18-.08-.21-.53,0-.42v.06c.37-.31-.35-.51-.14-.76-.74-.59-1.28-1.39-1.95-2l-.15.35-.23-.21c0-.12.1-.3.26-.15.05-.23-.39-.1-.45,0-.24-.39.4-.23.31-.32l-.16-.09v.06c-.21,0-.32.14-.51-.05s.07-.23,0-.28,0-.05-.07-.08L447,179l-.06.32c-.23,0-.27-.24-.35.13.12-.57-1-1.08-1-1.3a.9.9,0,0,1-.71-.36c0,.09-.16.38-.33.18.5-.47-.17-.53,0-1-.06.37-.61-.4-.68.14-.12-.18.15-.21.13-.43-.55-.13-.75-.86-1.28-1.19-.07.06-.07.24-.26.25l0-.56c-.13,0-.41.33-.39-.05,0,.07-.06.19-.14.16-.67-1.13-2.15-1.33-2.59-2.77,0,.24-.08.18-.18.11,0,.08-.14.17-.21.27l-.18-.6c-.29.2-.45-.34-.69-.12l.16.06c-.41.15-.29.85-.62,1.21.46-.18.09.91.79.69,0,.13-.15.07-.19.19.21-.1.33-.05.45.17l-.05,0c.52.38.61.71,1.07,1.29l.11-.23a.53.53,0,0,1,.1.3c.36-.17-.32-.29.05-.5-.15.51.84.71.6,1.23.18.15.12-.26.3-.11l0,.16.17-.11a.38.38,0,0,1,0,.42s-.11,0-.14-.05c0,.26.47.32.49.41l-.12-.22c.59.31,1.08,1,1.75,1.14l0-.12c.5.15.21.35.68.61h0a.45.45,0,0,1,.4.13c-.19,0,0,.36-.2.36.54.16.31,0,.84-.08l-.06.2c.2-.06.26-.12.5,0-.27,0-.05.33-.37.34.16.68.89.21.7.84.53-.24-.18-.53,0-.53,0-.21.4-.16.5,0s-.18.71.16,1c0,0-.06,0-.09,0,0,.21.36.07.39.36.28-.17.19.19.47-.1l-.38-.19c.25.06.71-.16.86.26a.88.88,0,0,1-.33,0c0,.16.22.08.23.25-.28.29-.44-.25-.82-.18,0,.21.54.08.18.34.48-.32.29.33.78.2l-.16.17c.06,0,.21,0,.27,0l-.32.14c.36-.05.21.48.49.52-.38-.31.09-.29.05-.56.66.14-.13.71.46,1-.09,0-.18-.33,0-.32a.87.87,0,0,1,.13.45c.37.25.1-.24.34-.23-.07.33.24.05.45.1l-.15.19c.29.45.42-.31.66.14l-.37.13.24.09-.21.19c.33,0,.36.1.51.32a.33.33,0,0,1,.48-.18c0,.21-.21.12,0,.3-.15.07-.33.17-.29-.09-.07.05-.16.07-.22.12,0,.24.3.3.39.37a.2.2,0,0,1-.06-.12l.57,0c0,.12-.09.14-.18.16.09,0,.21,0,.33.07-.16.13-.28.29-.49.24l.48.11c0,.09,0,.34-.06.36.11.24.7.08.85.41a.22.22,0,0,1,.16,0c.21.23.26.59.71.62l-.07.4c.27.12.07-.52.52-.32s-.09.31-.07.47c.24,0,.7-.14.75.29C453.48,187.57,453.45,187.48,453.36,187.44Zm2.79,2.13c-.09,0-.29,0-.24-.11C456.15,189.29,456.11,189.43,456.15,189.57Zm4.45,3c-.09,0-.12-.06-.13-.18A.22.22,0,0,1,460.6,192.54Zm12.45,8.21h0C473,200.58,473,200.64,473.05,200.75Zm.17.28a.09.09,0,0,0,.08-.07c-.06,0-.11,0-.16-.07S473.12,201,473.22,201Zm-26-21.63v.09C447.12,179.46,447.19,179.43,447.27,179.4Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.93,192.41a.23.23,0,0,1,.06-.12C459.94,192.3,459.91,192.34,459.93,192.41Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.61,186.14h0l0,0Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.18,199.51a.37.37,0,0,1,0-.18A.13.13,0,0,0,468.18,199.51Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.76,201.78l-.19-.08c.08.05.07.12.09.18S474.71,201.74,474.76,201.78Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.15,204.08s.05,0,.09,0l.07-.09C475.21,203.94,475.08,204,475.15,204.08Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.39,202.53c-.11.17,0,.2.16.26l0,0C474.74,202.58,474.57,202.55,474.39,202.53Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.58,202.8a.27.27,0,0,1,.1.08C474.77,202.81,474.66,202.83,474.58,202.8Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.62,201.18c0,.09.19-.18.17-.09C474,200.94,473.25,201.05,473.62,201.18Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.06 203.13 474.18 202.9 473.99 203.01 474.06 203.13",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.32,202.27l.13.2s.06,0,.1,0S473.36,202.21,473.32,202.27Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.55,202.44a.26.26,0,0,0,.16.09A.35.35,0,0,0,473.55,202.44Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.77 202.99 473.75 202.91 473.64 202.79 473.77 202.99",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.49,200.67l-.23-.1c-.08.05-.06.14,0,.17S471.47,200.76,471.49,200.67Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.62,201.69a.6.6,0,0,1,0-.22l-.2.24Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,201.29c-.08.05-.43,0-.18.15C470.92,201.39,471.16,201.49,471,201.29Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.44 198.6 468.49 198.63 468.8 198.23 468.44 198.6",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.15,197.46c.15.28.26-.21.36.08.13,0-.09-.23,0-.27C465.33,197.26,465.3,197.14,465.15,197.46Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.55,197.27h.11A.19.19,0,0,0,465.55,197.27Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.65 171.84 438.58 171.64 438.56 171.85 438.65 171.84",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.14,171.91l.17-.29-.27.16S438.16,171.83,438.14,171.91Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.13,190.42l.06,0c0-.09,0-.12-.06-.19Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.33 188.59 454.36 188.63 454.49 188.34 454.33 188.59",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.46,187.52c.06.06.18.08.24.14C452.52,187.58,452.67,187.21,452.46,187.52Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.78 180.36 266.08 180.36 265.62 178.44 290.32 178.44 290.78 180.36",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.06 184.57 267.08 184.57 266.63 182.66 280.6 182.66 281.06 184.57",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.51 354.15 351.81 354.15 351.35 352.23 376.05 352.23 376.51 354.15",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.8 358.36 352.82 358.36 352.36 356.44 366.34 356.44 366.8 358.36",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.66 309.92 429.96 309.92 429.5 308 454.2 308 454.66 309.92",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.91 318.34 431.97 318.34 431.51 316.42 444.45 316.42 444.91 318.34",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.78 314.13 430.96 314.13 430.5 312.21 448.32 312.21 448.78 314.13",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.77,336.47a28.59,28.59,0,0,1-16.36-4.71,17.61,17.61,0,0,1-7-9.42c-1.27-4.28-.94-7.89,1-10.73,2.7-4,8.53-6.32,16.86-6.65a1.34,1.34,0,0,1,1.29,1,.78.78,0,0,1-.72,1.05c-7.79.3-13.18,2.37-15.61,6-1.62,2.42-1.89,5.54-.79,9.26a14.79,14.79,0,0,0,5.89,8c4.79,3.37,11.62,4.83,18.78,4,10.76-1.23,15.22-6.34,12.54-14.38a10.38,10.38,0,0,0-4.36-5.27c-4.76-3.18-12.59-4.67-19.47-3.7a1.36,1.36,0,0,1-1.35-.87.79.79,0,0,1,.6-1.14c7.37-1,15.86.62,21.1,4.12a13.29,13.29,0,0,1,5.46,6.67c3.05,9.19-2,15.24-13.82,16.59A37.07,37.07,0,0,1,492.77,336.47Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.64,248.91H375.35a21.83,21.83,0,0,1-3.09-6.43l-6-25.86h32.29s4.54,19.65,6.05,26.2A22.77,22.77,0,0,0,407.64,248.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.61,224.25c3.72-.31,7.5-.38,11.3-.4s7.61.09,11.48.4c-3.72.32-7.5.39-11.3.4S377.48,224.56,373.61,224.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.59,228.51c3.34-.31,6.74-.38,10.15-.4s6.85.09,10.34.4c-3.34.31-6.74.39-10.15.4S378.08,228.82,374.59,228.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.57,232.77a84.18,84.18,0,0,1,8.87-.4,89.46,89.46,0,0,1,9.06.4c-2.92.31-5.89.38-8.87.4S378.63,233.08,375.57,232.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.56,237c3.72-.31,7.5-.38,11.29-.4s7.62.09,11.49.4c-3.73.32-7.51.39-11.3.4S380.42,237.33,376.56,237Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.86,379.72H495.57a21.68,21.68,0,0,1-3.08-6.42c-1.5-6.47-6-25.87-6-25.87h32.29l6,26.2A23.09,23.09,0,0,0,527.86,379.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.83,355.06c3.73-.31,7.51-.38,11.3-.4s7.61.09,11.48.4c-3.72.32-7.5.39-11.3.4S497.7,355.37,493.83,355.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.81,359.32c3.35-.31,6.75-.38,10.16-.4s6.85.09,10.34.4c-3.35.31-6.75.39-10.16.4S498.3,359.63,494.81,359.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.8,363.58a86.7,86.7,0,0,1,8.87-.4,89.27,89.27,0,0,1,9.05.4c-2.91.31-5.88.38-8.87.4S498.86,363.89,495.8,363.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.78,367.83c3.72-.31,7.51-.38,11.3-.4s7.61.09,11.48.4c-3.72.32-7.5.39-11.3.4S500.65,368.15,496.78,367.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.92,339.64H306.25a50.52,50.52,0,0,1-2-6.42c-1.49-6.47-6-25.87-6-25.87h32.29s4.53,19.65,6.05,26.2C337.18,336.17,331.92,339.64,331.92,339.64Z",
    style: {
      fill: "#0D47A1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.57,333.55c.59,2.54-4.34,5.87-4.64,6.08.79-.64-.53-5.7-.53-5.7S336.41,333.26,336.57,333.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.75,315c3.73-.32,7.51-.39,11.3-.4s7.62.08,11.49.4c-3.73.31-7.51.38-11.3.4S308.62,315.3,304.75,315Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.74,319.24c2.91-.31,5.88-.38,8.87-.4s6,.09,9.05.4a84.06,84.06,0,0,1-8.87.4C311.8,319.63,308.8,319.55,305.74,319.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.72,323.5c2.91-.31,5.88-.38,8.87-.4s6,.09,9.05.4c-2.91.31-5.88.38-8.87.4S309.78,323.81,306.72,323.5Z",
    style: {
      fill: "#fff"
    }
  })));
};
export { SvgCalendar as ReactComponent };
export default "/aa2f38ae0c638d049fe808c586dff5dd.svg";